export const all = [
  {
    id: 144,
    title: "Acabamento de Janelas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 483,
    title: "Acolchoamento",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 338,
    title: "Advogado - Direito Civil",
    sub_group_id: 61,
    created_at: null,
    updated_at: null
  },
  {
    id: 339,
    title: "Advogado - Direito Comercial",
    sub_group_id: 61,
    created_at: null,
    updated_at: null
  },
  {
    id: 340,
    title: "Advogado - Direito Criminal",
    sub_group_id: 61,
    created_at: null,
    updated_at: null
  },
  {
    id: 341,
    title: "Advogado - Direito Fiscal",
    sub_group_id: 61,
    created_at: null,
    updated_at: null
  },
  {
    id: 342,
    title: "Advogado - Direito Imobili\u00e1rio",
    sub_group_id: 61,
    created_at: null,
    updated_at: null
  },
  {
    id: 343,
    title: "Advogado - Direito Laboral",
    sub_group_id: 61,
    created_at: null,
    updated_at: null
  },
  {
    id: 344,
    title: "Advogado - Direito de Fam\u00edlia e Div\u00f3rcios",
    sub_group_id: 61,
    created_at: null,
    updated_at: null
  },
  {
    id: 458,
    title: "Advogado de Contratos",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 459,
    title: "Advogado de Danos Pessoais",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 460,
    title: "Advogado de Direito Internacional",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 461,
    title: "Advogado de Direito Internacional",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 462,
    title: "Advogado de Imigra\u00e7\u00e3o",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 463,
    title: "Advogado de Insolv\u00eancias",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 464,
    title: "Advogado de Marcas Registadas",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 465,
    title: "Advogado de Patentes",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 466,
    title: "Advogado de Propriedade Intelectual",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 467,
    title: "Advogado em Direito de Tr\u00e2nsito",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 468,
    title: "Advogado para Casos de Defici\u00eancia",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 469,
    title: "Advogados",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 440,
    title: "Afina\u00e7\u00e3o de Piano",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 345,
    title: "Agentes e Mediadores de Seguros",
    sub_group_id: 62,
    created_at: null,
    updated_at: null
  },
  {
    id: 346,
    title: "Ag\u00eancias de Viagens",
    sub_group_id: 63,
    created_at: null,
    updated_at: null
  },
  {
    id: 494,
    title: "Alojamento de Websites",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 111,
    title: "Alvenaria",
    sub_group_id: 21,
    created_at: null,
    updated_at: null
  },
  {
    id: 375,
    title: "Anima\u00e7\u00e3o Gr\u00e1fica",
    sub_group_id: 72,
    created_at: null,
    updated_at: null
  },
  {
    id: 107,
    title: "Antena Parab\u00f3lica",
    sub_group_id: 20,
    created_at: null,
    updated_at: null
  },
  {
    id: 7,
    title: "Apartamento Duplex",
    sub_group_id: 1,
    created_at: null,
    updated_at: null
  },
  {
    id: 1,
    title: "Apartamento T0",
    sub_group_id: 1,
    created_at: null,
    updated_at: null
  },
  {
    id: 2,
    title: "Apartamento T1",
    sub_group_id: 1,
    created_at: null,
    updated_at: null
  },
  {
    id: 3,
    title: "Apartamento T2",
    sub_group_id: 1,
    created_at: null,
    updated_at: null
  },
  {
    id: 4,
    title: "Apartamento T3",
    sub_group_id: 1,
    created_at: null,
    updated_at: null
  },
  {
    id: 5,
    title: "Apartamento T4",
    sub_group_id: 1,
    created_at: null,
    updated_at: null
  },
  {
    id: 6,
    title: "Apartamento T5",
    sub_group_id: 1,
    created_at: null,
    updated_at: null
  },
  {
    id: 226,
    title: "Aplica\u00e7\u00e3o de Estuque",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 89,
    title: "Aplica\u00e7\u00e3o de Pesticida no Exterior",
    sub_group_id: 18,
    created_at: null,
    updated_at: null
  },
  {
    id: 19,
    title: "Armaz\u00e9m",
    sub_group_id: 3,
    created_at: null,
    updated_at: null
  },
  {
    id: 72,
    title: "Arm\u00e1rios de Cozinha",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 73,
    title: "Arm\u00e1rios de Roupa",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 26,
    title: "Arquitetura",
    sub_group_id: 7,
    created_at: null,
    updated_at: null
  },
  {
    id: 27,
    title: "Arquitetura de interiores",
    sub_group_id: 7,
    created_at: null,
    updated_at: null
  },
  {
    id: 312,
    title: "Auditoria Energ\u00e9tica",
    sub_group_id: 55,
    created_at: null,
    updated_at: null
  },
  {
    id: 607,
    title: "Aulas de Alem\u00e3o",
    sub_group_id: 136,
    created_at: null,
    updated_at: null
  },
  {
    id: 508,
    title: "Aulas de Artes e Trabalhos Manuais",
    sub_group_id: 98,
    created_at: null,
    updated_at: null
  },
  {
    id: 524,
    title: "Aulas de Basquetebol",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 542,
    title: "Aulas de Canto",
    sub_group_id: 109,
    created_at: null,
    updated_at: null
  },
  {
    id: 543,
    title: "Aulas de Canto (para Adultos)",
    sub_group_id: 109,
    created_at: null,
    updated_at: null
  },
  {
    id: 544,
    title: "Aulas de Canto (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 109,
    created_at: null,
    updated_at: null
  },
  {
    id: 560,
    title: "Aulas de Composi\u00e7\u00e3o Musical",
    sub_group_id: 116,
    created_at: null,
    updated_at: null
  },
  {
    id: 574,
    title: "Aulas de Condu\u00e7\u00e3o",
    sub_group_id: 123,
    created_at: null,
    updated_at: null
  },
  {
    id: 551,
    title: "Aulas de Contrabaixo (para Adultos)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null
  },
  {
    id: 552,
    title: "Aulas de Contrabaixo (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null
  },
  {
    id: 512,
    title: "Aulas de Coreografia",
    sub_group_id: 100,
    created_at: null,
    updated_at: null
  },
  {
    id: 537,
    title: "Aulas de Corrida e Jogging",
    sub_group_id: 105,
    created_at: null,
    updated_at: null
  },
  {
    id: 509,
    title: "Aulas de Costura",
    sub_group_id: 99,
    created_at: null,
    updated_at: null
  },
  {
    id: 510,
    title: "Aulas de Croch\u00e9",
    sub_group_id: 99,
    created_at: null,
    updated_at: null
  },
  {
    id: 513,
    title: "Aulas de Dan\u00e7a Privadas",
    sub_group_id: 100,
    created_at: null,
    updated_at: null
  },
  {
    id: 514,
    title: "Aulas de Dan\u00e7a de Sal\u00e3o",
    sub_group_id: 100,
    created_at: null,
    updated_at: null
  },
  {
    id: 519,
    title: "Aulas de Defesa Pessoal",
    sub_group_id: 101,
    created_at: null,
    updated_at: null
  },
  {
    id: 521,
    title: "Aulas de Desenho",
    sub_group_id: 102,
    created_at: null,
    updated_at: null
  },
  {
    id: 535,
    title: "Aulas de Equita\u00e7\u00e3o (para Adultos)",
    sub_group_id: 104,
    created_at: null,
    updated_at: null
  },
  {
    id: 536,
    title: "Aulas de Equita\u00e7\u00e3o (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 104,
    created_at: null,
    updated_at: null
  },
  {
    id: 522,
    title: "Aulas de Escultura",
    sub_group_id: 102,
    created_at: null,
    updated_at: null
  },
  {
    id: 608,
    title: "Aulas de Espanhol",
    sub_group_id: 137,
    created_at: null,
    updated_at: null
  },
  {
    id: 539,
    title: "Aulas de Fotografia",
    sub_group_id: 106,
    created_at: null,
    updated_at: null
  },
  {
    id: 609,
    title: "Aulas de Franc\u00eas",
    sub_group_id: 138,
    created_at: null,
    updated_at: null
  },
  {
    id: 525,
    title: "Aulas de Futebol",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 526,
    title: "Aulas de Golfe",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 546,
    title: "Aulas de Guitarra",
    sub_group_id: 111,
    created_at: null,
    updated_at: null
  },
  {
    id: 547,
    title: "Aulas de Guitarra (para Adultos)",
    sub_group_id: 111,
    created_at: null,
    updated_at: null
  },
  {
    id: 548,
    title: "Aulas de Guitarra (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 111,
    created_at: null,
    updated_at: null
  },
  {
    id: 549,
    title: "Aulas de Guitarra Baixo",
    sub_group_id: 111,
    created_at: null,
    updated_at: null
  },
  {
    id: 553,
    title: "Aulas de Harm\u00f3nica",
    sub_group_id: 113,
    created_at: null,
    updated_at: null
  },
  {
    id: 554,
    title: "Aulas de Harpa (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null
  },
  {
    id: 540,
    title: "Aulas de Inform\u00e1tica",
    sub_group_id: 107,
    created_at: null,
    updated_at: null
  },
  {
    id: 610,
    title: "Aulas de Ingl\u00eas",
    sub_group_id: 139,
    created_at: null,
    updated_at: null
  },
  {
    id: 611,
    title: "Aulas de Italiano",
    sub_group_id: 140,
    created_at: null,
    updated_at: null
  },
  {
    id: 612,
    title: "Aulas de Japon\u00eas",
    sub_group_id: 141,
    created_at: null,
    updated_at: null
  },
  {
    id: 506,
    title: "Aulas de Judo",
    sub_group_id: 97,
    created_at: null,
    updated_at: null
  },
  {
    id: 507,
    title: "Aulas de Karat\u00e9",
    sub_group_id: 97,
    created_at: null,
    updated_at: null
  },
  {
    id: 527,
    title: "Aulas de Kitesurf",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 515,
    title: "Aulas de Kizomba",
    sub_group_id: 100,
    created_at: null,
    updated_at: null
  },
  {
    id: 520,
    title: "Aulas de Krav Maga",
    sub_group_id: 101,
    created_at: null,
    updated_at: null
  },
  {
    id: 613,
    title: "Aulas de Linguagem Gestual",
    sub_group_id: 141,
    created_at: null,
    updated_at: null
  },
  {
    id: 614,
    title: "Aulas de Mandarim",
    sub_group_id: 141,
    created_at: null,
    updated_at: null
  },
  {
    id: 597,
    title: "Aulas de Maquilhagem",
    sub_group_id: 134,
    created_at: null,
    updated_at: null
  },
  {
    id: 528,
    title: "Aulas de Mergulho",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 541,
    title: "Aulas de M\u00fasica - Bateria",
    sub_group_id: 108,
    created_at: null,
    updated_at: null
  },
  {
    id: 545,
    title: "Aulas de M\u00fasica - Clarinete",
    sub_group_id: 110,
    created_at: null,
    updated_at: null
  },
  {
    id: 529,
    title: "Aulas de Nata\u00e7\u00e3o Privadas (individuais ou em grupo)",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 555,
    title: "Aulas de Obo\u00e9 (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null
  },
  {
    id: 550,
    title: "Aulas de Org\u00e3o",
    sub_group_id: 112,
    created_at: null,
    updated_at: null
  },
  {
    id: 556,
    title: "Aulas de Piano",
    sub_group_id: 114,
    created_at: null,
    updated_at: null
  },
  {
    id: 557,
    title: "Aulas de Piano (para Adultos)",
    sub_group_id: 114,
    created_at: null,
    updated_at: null
  },
  {
    id: 558,
    title: "Aulas de Piano (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 114,
    created_at: null,
    updated_at: null
  },
  {
    id: 523,
    title: "Aulas de Pintura",
    sub_group_id: 102,
    created_at: null,
    updated_at: null
  },
  {
    id: 615,
    title: "Aulas de Portugu\u00eas (como Segunda L\u00edngua)",
    sub_group_id: 142,
    created_at: null,
    updated_at: null
  },
  {
    id: 571,
    title: "Aulas de Reanima\u00e7\u00e3o Neonatal",
    sub_group_id: 122,
    created_at: null,
    updated_at: null
  },
  {
    id: 516,
    title: "Aulas de Salsa Privadas",
    sub_group_id: 100,
    created_at: null,
    updated_at: null
  },
  {
    id: 517,
    title: "Aulas de Sapateado",
    sub_group_id: 100,
    created_at: null,
    updated_at: null
  },
  {
    id: 559,
    title: "Aulas de Saxofone",
    sub_group_id: 115,
    created_at: null,
    updated_at: null
  },
  {
    id: 598,
    title: "Aulas de Soldagem",
    sub_group_id: 134,
    created_at: null,
    updated_at: null
  },
  {
    id: 530,
    title: "Aulas de Stand-Up Paddle",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 531,
    title: "Aulas de Surf",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 518,
    title: "Aulas de Tango",
    sub_group_id: 100,
    created_at: null,
    updated_at: null
  },
  {
    id: 561,
    title: "Aulas de Teoria Musical",
    sub_group_id: 116,
    created_at: null,
    updated_at: null
  },
  {
    id: 511,
    title: "Aulas de Tric\u00f4",
    sub_group_id: 99,
    created_at: null,
    updated_at: null
  },
  {
    id: 562,
    title: "Aulas de Trompete",
    sub_group_id: 117,
    created_at: null,
    updated_at: null
  },
  {
    id: 532,
    title: "Aulas de T\u00e9nis Privadas (individuais ou em grupo)",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 563,
    title: "Aulas de Ukelele",
    sub_group_id: 118,
    created_at: null,
    updated_at: null
  },
  {
    id: 564,
    title: "Aulas de Viola",
    sub_group_id: 119,
    created_at: null,
    updated_at: null
  },
  {
    id: 565,
    title: "Aulas de Viola (para Adultos)",
    sub_group_id: 119,
    created_at: null,
    updated_at: null
  },
  {
    id: 566,
    title: "Aulas de Viola (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 119,
    created_at: null,
    updated_at: null
  },
  {
    id: 567,
    title: "Aulas de Violino",
    sub_group_id: 120,
    created_at: null,
    updated_at: null
  },
  {
    id: 568,
    title: "Aulas de Violino (para Adultos)",
    sub_group_id: 120,
    created_at: null,
    updated_at: null
  },
  {
    id: 569,
    title: "Aulas de Violino (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 120,
    created_at: null,
    updated_at: null
  },
  {
    id: 570,
    title: "Aulas de Violoncelo",
    sub_group_id: 121,
    created_at: null,
    updated_at: null
  },
  {
    id: 533,
    title: "Aulas de Voleibol",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 534,
    title: "Aulas de Xadrez",
    sub_group_id: 103,
    created_at: null,
    updated_at: null
  },
  {
    id: 538,
    title: "Aulas de Zumba",
    sub_group_id: 105,
    created_at: null,
    updated_at: null
  },
  {
    id: 347,
    title: "Autocad e Modela\u00e7\u00e3o",
    sub_group_id: 64,
    created_at: null,
    updated_at: null
  },
  {
    id: 95,
    title: "Automa\u00e7\u00e3o Residencial e Dom\u00f3tica",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 348,
    title: "Babysitting",
    sub_group_id: 65,
    created_at: null,
    updated_at: null
  },
  {
    id: 484,
    title: "Bordados",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 112,
    title: "Calafetagem",
    sub_group_id: 21,
    created_at: null,
    updated_at: null
  },
  {
    id: 54,
    title: "Canaliza\u00e7\u00e3o",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 55,
    title: "Canos Furados ou Problemas com Torneiras",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 74,
    title: "Carpintaria Geral",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 75,
    title: "Carpintaria de Obras",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 417,
    title: "Cat Sitting",
    sub_group_id: 81,
    created_at: null,
    updated_at: null
  },
  {
    id: 410,
    title: "Centro de C\u00f3pias",
    sub_group_id: 78,
    created_at: null,
    updated_at: null
  },
  {
    id: 313,
    title: "Certifica\u00e7\u00e3o Ac\u00fastica",
    sub_group_id: 56,
    created_at: null,
    updated_at: null
  },
  {
    id: 311,
    title: "Certifica\u00e7\u00e3o Energ\u00e9tica de edificios",
    sub_group_id: 55,
    created_at: null,
    updated_at: null
  },
  {
    id: 314,
    title: "Certifica\u00e7\u00e3o de Instala\u00e7\u00f5es El\u00e9ctricas",
    sub_group_id: 57,
    created_at: null,
    updated_at: null
  },
  {
    id: 485,
    title: "Cestos Presente Personalizados",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 145,
    title: "Clarab\u00f3ias",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 212,
    title: "Coloca\u00e7\u00e3o de Pedra",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 414,
    title: "Composi\u00e7\u00e3o de Can\u00e7\u00f5es",
    sub_group_id: 79,
    created_at: null,
    updated_at: null
  },
  {
    id: 259,
    title: "Constru\u00e7\u00e3o Civil",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 260,
    title: "Constru\u00e7\u00e3o de Casa Nova",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 121,
    title: "Constru\u00e7\u00e3o de Equipamento de Divers\u00e3o Infantil",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 261,
    title: "Constru\u00e7\u00e3o de Parede Interior",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 252,
    title: "Constru\u00e7\u00e3o de Piscina Abaixo do Solo",
    sub_group_id: 46,
    created_at: null,
    updated_at: null
  },
  {
    id: 122,
    title: "Constru\u00e7\u00e3o de Po\u00e7o",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 262,
    title: "Constru\u00e7\u00e3o de P\u00e1tio",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 263,
    title: "Constru\u00e7\u00e3o de Teto Falso",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 227,
    title:
      "Constru\u00e7\u00e3o ou Remodela\u00e7\u00e3o de Escadas e Escadarias",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 351,
    title: "Consultoria Empresarial",
    sub_group_id: 67,
    created_at: null,
    updated_at: null
  },
  {
    id: 486,
    title: "Consultoria de Belas Artes",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 355,
    title: "Consultoria de E-commerce",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 356,
    title: "Consultoria de Estrat\u00e9gia de Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 352,
    title: "Consultoria de Estrat\u00e9gia e Opera\u00e7\u00f5es",
    sub_group_id: 67,
    created_at: null,
    updated_at: null
  },
  {
    id: 349,
    title: "Consultoria e Aconselhamento de Seguran\u00e7a Social",
    sub_group_id: 66,
    created_at: null,
    updated_at: null
  },
  {
    id: 353,
    title: "Consultoria e Desenvolvimento de Franchising",
    sub_group_id: 67,
    created_at: null,
    updated_at: null
  },
  {
    id: 367,
    title: "Contabilidade",
    sub_group_id: 70,
    created_at: null,
    updated_at: null
  },
  {
    id: 90,
    title: "Controlo de Pragas",
    sub_group_id: 18,
    created_at: null,
    updated_at: null
  },
  {
    id: 28,
    title: "Corte de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null
  },
  {
    id: 155,
    title: "Corte e Apara\u00e7\u00e3o de Relvado",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 156,
    title: "Corte e Apara\u00e7\u00e3o de Relvado (Recorrente)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 402,
    title: "Creche para C\u00e3es",
    sub_group_id: 75,
    created_at: null,
    updated_at: null
  },
  {
    id: 487,
    title: "Croch\u00e9",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 371,
    title: "Cuidados para Animais",
    sub_group_id: 71,
    created_at: null,
    updated_at: null
  },
  {
    id: 372,
    title: "Cuidados para C\u00e3es",
    sub_group_id: 71,
    created_at: null,
    updated_at: null
  },
  {
    id: 373,
    title: "Cuidados para Gatos",
    sub_group_id: 71,
    created_at: null,
    updated_at: null
  },
  {
    id: 80,
    title: "Decora\u00e7\u00e3o de Interiores",
    sub_group_id: 14,
    created_at: null,
    updated_at: null
  },
  {
    id: 157,
    title: "Delimita\u00e7\u00e3o de Relvados",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 264,
    title: "Demoli\u00e7\u00e3o de Constru\u00e7\u00f5es",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 83,
    title: "Desenho T\u00e9cnico",
    sub_group_id: 15,
    created_at: null,
    updated_at: null
  },
  {
    id: 84,
    title: "Desenho de Engenharia",
    sub_group_id: 15,
    created_at: null,
    updated_at: null
  },
  {
    id: 495,
    title: "Desenvolvimento de Aplica\u00e7\u00f5es iOS",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 496,
    title: "Desenvolvimento de Jogos para Dispositivos M\u00f3veis",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 497,
    title: "Desenvolvimento de Software",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 498,
    title: "Desenvolvimento de Software Mobile",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 376,
    title: "Design Gr\u00e1fico",
    sub_group_id: 72,
    created_at: null,
    updated_at: null
  },
  {
    id: 499,
    title: "Design de Aplica\u00e7\u00f5es M\u00f3veis",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 377,
    title: "Design de Apresenta\u00e7\u00f5es",
    sub_group_id: 72,
    created_at: null,
    updated_at: null
  },
  {
    id: 500,
    title: "Design de Blogs",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 378,
    title: "Design de Impress\u00e3o",
    sub_group_id: 72,
    created_at: null,
    updated_at: null
  },
  {
    id: 87,
    title: "Design de Interiores",
    sub_group_id: 17,
    created_at: null,
    updated_at: null
  },
  {
    id: 379,
    title: "Design de Logotipos",
    sub_group_id: 72,
    created_at: null,
    updated_at: null
  },
  {
    id: 213,
    title: "Design de Paisagismo de Exteriores",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 501,
    title: "Design de UI",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 357,
    title: "Direct Mail Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 265,
    title: "Divis\u00e3o de Quarto",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 418,
    title: "Dog Sitting",
    sub_group_id: 81,
    created_at: null,
    updated_at: null
  },
  {
    id: 419,
    title: "Dog Walking",
    sub_group_id: 81,
    created_at: null,
    updated_at: null
  },
  {
    id: 85,
    title: "Drenagem Lenta ou Entupida",
    sub_group_id: 16,
    created_at: null,
    updated_at: null
  },
  {
    id: 502,
    title: "E-commerce",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 382,
    title: "Edi\u00e7\u00e3o de Conte\u00fados",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 383,
    title: "Elabora\u00e7\u00e3o de Curr\u00edculos",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 96,
    title: "Eletricistas",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 91,
    title: "Elimina\u00e7\u00e3o de Animais e Roedores",
    sub_group_id: 18,
    created_at: null,
    updated_at: null
  },
  {
    id: 358,
    title: "Email Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 200,
    title: "Embalar e Desembalar M\u00f3veis",
    sub_group_id: 37,
    created_at: null,
    updated_at: null
  },
  {
    id: 86,
    title: "Empresas de Desentupimentos",
    sub_group_id: 16,
    created_at: null,
    updated_at: null
  },
  {
    id: 92,
    title: "Empresas de Desinfesta\u00e7\u00e3o",
    sub_group_id: 18,
    created_at: null,
    updated_at: null
  },
  {
    id: 380,
    title: "Entrega de Refei\u00e7\u00f5es",
    sub_group_id: 73,
    created_at: null,
    updated_at: null
  },
  {
    id: 381,
    title: "Entregas e Servi\u00e7os de Estafetas",
    sub_group_id: 73,
    created_at: null,
    updated_at: null
  },
  {
    id: 384,
    title: "Escrita",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 385,
    title: "Escrita de Conte\u00fados Online",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 386,
    title: "Escrita em Blog",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 17,
    title: "Escrit\u00f3rio",
    sub_group_id: 3,
    created_at: null,
    updated_at: null
  },
  {
    id: 470,
    title: "Especialistas em Servi\u00e7os Legais",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 471,
    title: "Especialistas em Servi\u00e7os Processuais",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 115,
    title: "Estofador",
    sub_group_id: 22,
    created_at: null,
    updated_at: null
  },
  {
    id: 422,
    title: "Estofador de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null
  },
  {
    id: 214,
    title: "Estufas",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 580,
    title: "Explica\u00e7\u00f5es de Biologia",
    sub_group_id: 125,
    created_at: null,
    updated_at: null
  },
  {
    id: 581,
    title: "Explica\u00e7\u00f5es de Ci\u00eancias",
    sub_group_id: 126,
    created_at: null,
    updated_at: null
  },
  {
    id: 587,
    title: "Explica\u00e7\u00f5es de C\u00e1lculo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 582,
    title: "Explica\u00e7\u00f5es de Economia",
    sub_group_id: 127,
    created_at: null,
    updated_at: null
  },
  {
    id: 583,
    title: "Explica\u00e7\u00f5es de Estat\u00edstica",
    sub_group_id: 128,
    created_at: null,
    updated_at: null
  },
  {
    id: 584,
    title: "Explica\u00e7\u00f5es de F\u00edsica",
    sub_group_id: 129,
    created_at: null,
    updated_at: null
  },
  {
    id: 585,
    title: "Explica\u00e7\u00f5es de Geometria",
    sub_group_id: 130,
    created_at: null,
    updated_at: null
  },
  {
    id: 586,
    title: "Explica\u00e7\u00f5es de Hist\u00f3ria",
    sub_group_id: 131,
    created_at: null,
    updated_at: null
  },
  {
    id: 588,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica de Ensino Secund\u00e1rio",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 589,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica de Mestrado",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 590,
    title:
      "Explica\u00e7\u00f5es de Matem\u00e1tica de N\u00edvel Universit\u00e1rio",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 591,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica do 1\u00ba Ciclo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 592,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica do 2\u00ba Ciclo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 593,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica do 3\u00ba Ciclo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 575,
    title: "Explica\u00e7\u00f5es de Prepara\u00e7\u00e3o para o GMAT",
    sub_group_id: 124,
    created_at: null,
    updated_at: null
  },
  {
    id: 576,
    title:
      "Explica\u00e7\u00f5es de Prepara\u00e7\u00e3o para os Exames Nacionais",
    sub_group_id: 124,
    created_at: null,
    updated_at: null
  },
  {
    id: 596,
    title: "Explica\u00e7\u00f5es de Qu\u00edmica",
    sub_group_id: 133,
    created_at: null,
    updated_at: null
  },
  {
    id: 594,
    title: "Explica\u00e7\u00f5es de Trigonometria",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 577,
    title: "Explica\u00e7\u00f5es de V\u00e1rias Disciplinas",
    sub_group_id: 124,
    created_at: null,
    updated_at: null
  },
  {
    id: 595,
    title: "Explica\u00e7\u00f5es de \u00c1lgebra",
    sub_group_id: 132,
    created_at: null,
    updated_at: null
  },
  {
    id: 578,
    title: "Explica\u00e7\u00f5es para o Exame LSAT",
    sub_group_id: 124,
    created_at: null,
    updated_at: null
  },
  {
    id: 266,
    title: "Extens\u00e3o de Quarto",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 93,
    title: "Exterm\u00ednio de Percevejos",
    sub_group_id: 18,
    created_at: null,
    updated_at: null
  },
  {
    id: 488,
    title: "Fabrico de Pl\u00e1stico",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 158,
    title: "Fertiliza\u00e7\u00e3o",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 97,
    title: "Fia\u00e7\u00e3o",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 579,
    title: "Forma\u00e7\u00e3o de Professores",
    sub_group_id: 124,
    created_at: null,
    updated_at: null
  },
  {
    id: 600,
    title: "Forma\u00e7\u00e3o em Contabilidade",
    sub_group_id: 135,
    created_at: null,
    updated_at: null
  },
  {
    id: 601,
    title: "Forma\u00e7\u00e3o em Desenvolvimento de Lideran\u00e7a",
    sub_group_id: 135,
    created_at: null,
    updated_at: null
  },
  {
    id: 602,
    title: "Forma\u00e7\u00e3o em Finan\u00e7as Empresariais",
    sub_group_id: 135,
    created_at: null,
    updated_at: null
  },
  {
    id: 603,
    title: "Forma\u00e7\u00e3o em Finan\u00e7as Pessoais",
    sub_group_id: 135,
    created_at: null,
    updated_at: null
  },
  {
    id: 599,
    title: "Forma\u00e7\u00e3o em Imobili\u00e1ria",
    sub_group_id: 134,
    created_at: null,
    updated_at: null
  },
  {
    id: 604,
    title: "Forma\u00e7\u00e3o em Marketing",
    sub_group_id: 135,
    created_at: null,
    updated_at: null
  },
  {
    id: 605,
    title: "Forma\u00e7\u00e3o em Otimiza\u00e7\u00e3o de Motores de Busca",
    sub_group_id: 135,
    created_at: null,
    updated_at: null
  },
  {
    id: 572,
    title: "Forma\u00e7\u00e3o em Primeiros Socorros",
    sub_group_id: 122,
    created_at: null,
    updated_at: null
  },
  {
    id: 573,
    title: "Forma\u00e7\u00e3o em Seguran\u00e7a e Primeiros Socorros",
    sub_group_id: 122,
    created_at: null,
    updated_at: null
  },
  {
    id: 606,
    title: "Forma\u00e7\u00e3o em Vendas",
    sub_group_id: 135,
    created_at: null,
    updated_at: null
  },
  {
    id: 476,
    title: "Genealogia",
    sub_group_id: 91,
    created_at: null,
    updated_at: null
  },
  {
    id: 134,
    title: "Gest\u00e3o de Condom\u00ednios",
    sub_group_id: 27,
    created_at: null,
    updated_at: null
  },
  {
    id: 354,
    title: "Gest\u00e3o de Projetos",
    sub_group_id: 67,
    created_at: null,
    updated_at: null
  },
  {
    id: 415,
    title: "Grava\u00e7\u00e3o de M\u00fasica",
    sub_group_id: 79,
    created_at: null,
    updated_at: null
  },
  {
    id: 489,
    title: "Grava\u00e7\u00e3o de Objetos",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 403,
    title: "Hotel de Animais de Estima\u00e7\u00e3o",
    sub_group_id: 75,
    created_at: null,
    updated_at: null
  },
  {
    id: 404,
    title: "Hotel para C\u00e3es",
    sub_group_id: 75,
    created_at: null,
    updated_at: null
  },
  {
    id: 405,
    title: "Hotel para Gatos",
    sub_group_id: 75,
    created_at: null,
    updated_at: null
  },
  {
    id: 137,
    title: "Ilumina\u00e7\u00e3o Exterior",
    sub_group_id: 29,
    created_at: null,
    updated_at: null
  },
  {
    id: 409,
    title: "Ilustra\u00e7\u00e3o",
    sub_group_id: 77,
    created_at: null,
    updated_at: null
  },
  {
    id: 141,
    title: "Impermeabiliza\u00e7\u00e3o da Casa",
    sub_group_id: 30,
    created_at: null,
    updated_at: null
  },
  {
    id: 267,
    title: "Impermeabiliza\u00e7\u00e3o de Alpendre",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 411,
    title: "Impress\u00e3o em 3D",
    sub_group_id: 78,
    created_at: null,
    updated_at: null
  },
  {
    id: 20,
    title: "Industrial",
    sub_group_id: 3,
    created_at: null,
    updated_at: null
  },
  {
    id: 228,
    title: "Insonoriza\u00e7\u00e3o",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 315,
    title: "Inspe\u00e7\u00e3o da Qualidade do Ar",
    sub_group_id: 58,
    created_at: null,
    updated_at: null
  },
  {
    id: 316,
    title: "Inspe\u00e7\u00e3o de Bolor",
    sub_group_id: 58,
    created_at: null,
    updated_at: null
  },
  {
    id: 317,
    title: "Inspe\u00e7\u00e3o de Chamin\u00e9",
    sub_group_id: 58,
    created_at: null,
    updated_at: null
  },
  {
    id: 318,
    title: "Inspe\u00e7\u00e3o de Condom\u00ednio",
    sub_group_id: 58,
    created_at: null,
    updated_at: null
  },
  {
    id: 319,
    title: "Inspe\u00e7\u00e3o de Extintores",
    sub_group_id: 58,
    created_at: null,
    updated_at: null
  },
  {
    id: 320,
    title: "Inspe\u00e7\u00e3o de T\u00e9rmites e Pragas",
    sub_group_id: 58,
    created_at: null,
    updated_at: null
  },
  {
    id: 181,
    title: "Inspe\u00e7\u00e3o e Remo\u00e7\u00e3o de Bolor",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 44,
    title: "Inspe\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Caldeira a Vapor",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 45,
    title: "Inspe\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Esquentador",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 293,
    title: "Instala\u00e7\u00e3o de Alarme e Seguran\u00e7a Domicili\u00e1ria",
    sub_group_id: 49,
    created_at: null,
    updated_at: null
  },
  {
    id: 268,
    title: "Instala\u00e7\u00e3o de Alicerces",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 269,
    title: "Instala\u00e7\u00e3o de Alpendres",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 321,
    title: "Instala\u00e7\u00e3o de Aquecimento Central",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 329,
    title: "Instala\u00e7\u00e3o de Ar Condicionado",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 330,
    title: "Instala\u00e7\u00e3o de Ar Condicionado de Parede ou Port\u00e1til",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 76,
    title: "Instala\u00e7\u00e3o de Arm\u00e1rios Pr\u00e9-fabricados",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 29,
    title: "Instala\u00e7\u00e3o de Asfalto",
    sub_group_id: 8,
    created_at: null,
    updated_at: null
  },
  {
    id: 108,
    title: "Instala\u00e7\u00e3o de Aspira\u00e7\u00e3o Central",
    sub_group_id: 20,
    created_at: null,
    updated_at: null
  },
  {
    id: 172,
    title: "Instala\u00e7\u00e3o de Azulejos",
    sub_group_id: 33,
    created_at: null,
    updated_at: null
  },
  {
    id: 173,
    title: "Instala\u00e7\u00e3o de Azulejos de Cer\u00e2mica ou Porcelana",
    sub_group_id: 33,
    created_at: null,
    updated_at: null
  },
  {
    id: 35,
    title: "Instala\u00e7\u00e3o de Bancada de Cozinha",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 56,
    title: "Instala\u00e7\u00e3o de Banheira e Chuveiro",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 30,
    title: "Instala\u00e7\u00e3o de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null
  },
  {
    id: 322,
    title: "Instala\u00e7\u00e3o de Caldeira",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 46,
    title: "Instala\u00e7\u00e3o de Caldeira",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 47,
    title: "Instala\u00e7\u00e3o de Caldeira a Vapor",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 138,
    title: "Instala\u00e7\u00e3o de Candeeiros",
    sub_group_id: 29,
    created_at: null,
    updated_at: null
  },
  {
    id: 123,
    title: "Instala\u00e7\u00e3o de Cerca",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 124,
    title: "Instala\u00e7\u00e3o de Cerca para C\u00e3es",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 125,
    title: "Instala\u00e7\u00e3o de Cobertura de P\u00e1tio",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 98,
    title: "Instala\u00e7\u00e3o de Disjuntor ou Caixa de Fus\u00edveis",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 109,
    title: "Instala\u00e7\u00e3o de Eletrodom\u00e9sticos",
    sub_group_id: 20,
    created_at: null,
    updated_at: null
  },
  {
    id: 229,
    title: "Instala\u00e7\u00e3o de Escadas",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 117,
    title: "Instala\u00e7\u00e3o de Estores",
    sub_group_id: 23,
    created_at: null,
    updated_at: null
  },
  {
    id: 57,
    title: "Instala\u00e7\u00e3o de Fossa S\u00e9ptica",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 132,
    title: "Instala\u00e7\u00e3o de Frigor\u00edfico",
    sub_group_id: 26,
    created_at: null,
    updated_at: null
  },
  {
    id: 99,
    title: "Instala\u00e7\u00e3o de Gerador",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 270,
    title: "Instala\u00e7\u00e3o de Ilha de Cozinha",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 139,
    title: "Instala\u00e7\u00e3o de Ilumina\u00e7\u00e3o",
    sub_group_id: 29,
    created_at: null,
    updated_at: null
  },
  {
    id: 100,
    title: "Instala\u00e7\u00e3o de Interruptores e Tomadas",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 253,
    title: "Instala\u00e7\u00e3o de Jacuzzi e Spa",
    sub_group_id: 46,
    created_at: null,
    updated_at: null
  },
  {
    id: 146,
    title: "Instala\u00e7\u00e3o de Janelas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 147,
    title: "Instala\u00e7\u00e3o de Janelas de Alum\u00ednio",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 148,
    title: "Instala\u00e7\u00e3o de Janelas de PVC",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 323,
    title: "Instala\u00e7\u00e3o de Lareiras e Chamin\u00e9s",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 58,
    title: "Instala\u00e7\u00e3o de Lavat\u00f3rio e Torneira",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 101,
    title: "Instala\u00e7\u00e3o de L\u00e2mpada",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 149,
    title: "Instala\u00e7\u00e3o de Marquises",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 205,
    title: "Instala\u00e7\u00e3o de M\u00e1quina de Lavar Loi\u00e7a",
    sub_group_id: 38,
    created_at: null,
    updated_at: null
  },
  {
    id: 207,
    title: "Instala\u00e7\u00e3o de M\u00e1quina de Lavar Roupa",
    sub_group_id: 39,
    created_at: null,
    updated_at: null
  },
  {
    id: 209,
    title: "Instala\u00e7\u00e3o de Painel Solar",
    sub_group_id: 40,
    created_at: null,
    updated_at: null
  },
  {
    id: 224,
    title: "Instala\u00e7\u00e3o de Papel de Parede",
    sub_group_id: 42,
    created_at: null,
    updated_at: null
  },
  {
    id: 230,
    title: "Instala\u00e7\u00e3o de Paredes de Pladur",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 235,
    title: "Instala\u00e7\u00e3o de Pavimento Flutuante",
    sub_group_id: 44,
    created_at: null,
    updated_at: null
  },
  {
    id: 236,
    title: "Instala\u00e7\u00e3o de Pavimento Vin\u00edlico ou Lin\u00f3leo",
    sub_group_id: 44,
    created_at: null,
    updated_at: null
  },
  {
    id: 237,
    title: "Instala\u00e7\u00e3o de Pavimento em Bet\u00e3o",
    sub_group_id: 44,
    created_at: null,
    updated_at: null
  },
  {
    id: 238,
    title: "Instala\u00e7\u00e3o de Pavimento em Madeira",
    sub_group_id: 44,
    created_at: null,
    updated_at: null
  },
  {
    id: 239,
    title: "Instala\u00e7\u00e3o de Pavimento em Pedra ou Ladrilho",
    sub_group_id: 44,
    created_at: null,
    updated_at: null
  },
  {
    id: 254,
    title: "Instala\u00e7\u00e3o de Piscina",
    sub_group_id: 46,
    created_at: null,
    updated_at: null
  },
  {
    id: 255,
    title: "Instala\u00e7\u00e3o de Piscina Acima do Solo",
    sub_group_id: 46,
    created_at: null,
    updated_at: null
  },
  {
    id: 240,
    title: "Instala\u00e7\u00e3o de Piso Aquecido",
    sub_group_id: 44,
    created_at: null,
    updated_at: null
  },
  {
    id: 295,
    title: "Instala\u00e7\u00e3o de Porta para Animais de Estima\u00e7\u00e3o",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 150,
    title: "Instala\u00e7\u00e3o de Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 296,
    title: "Instala\u00e7\u00e3o de Portas",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 324,
    title: "Instala\u00e7\u00e3o de Recuperador de Calor",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 215,
    title: "Instala\u00e7\u00e3o de Relva Artificial",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 216,
    title: "Instala\u00e7\u00e3o de Relvado",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 325,
    title: "Instala\u00e7\u00e3o de Salamandra",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 59,
    title: "Instala\u00e7\u00e3o de Sanita",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 256,
    title: "Instala\u00e7\u00e3o de Sauna",
    sub_group_id: 46,
    created_at: null,
    updated_at: null
  },
  {
    id: 217,
    title: "Instala\u00e7\u00e3o de Sistema de Irriga\u00e7\u00e3o",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 218,
    title: "Instala\u00e7\u00e3o de Sistema de Rega Gota a Gota",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 60,
    title: "Instala\u00e7\u00e3o de Sistema de Tratamento de \u00c1gua",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 126,
    title: "Instala\u00e7\u00e3o de Terra\u00e7o",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 306,
    title: "Instala\u00e7\u00e3o de Toldos",
    sub_group_id: 52,
    created_at: null,
    updated_at: null
  },
  {
    id: 61,
    title: "Instala\u00e7\u00e3o de Tubos de Canaliza\u00e7\u00e3o",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 102,
    title: "Instala\u00e7\u00e3o de Ventoinha",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 429,
    title: "Instala\u00e7\u00e3o e Configura\u00e7\u00e3o de Router",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 140,
    title:
      "Instala\u00e7\u00e3o e Remo\u00e7\u00e3o de Ilumina\u00e7\u00f5es para Festividades",
    sub_group_id: 29,
    created_at: null,
    updated_at: null
  },
  {
    id: 294,
    title:
      "Instala\u00e7\u00e3o e Repara\u00e7\u00e3o de C\u00e2maras de Vigil\u00e2ncia",
    sub_group_id: 49,
    created_at: null,
    updated_at: null
  },
  {
    id: 103,
    title: "Instala\u00e7\u00e3o e Repara\u00e7\u00e3o de Intercomunicadores",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 135,
    title: "Instala\u00e7\u00e3o e Verifica\u00e7\u00e3o de G\u00e1s",
    sub_group_id: 28,
    created_at: null,
    updated_at: null
  },
  {
    id: 142,
    title: "Instala\u00e7\u00e3o ou Atualiza\u00e7\u00e3o de Isolamento",
    sub_group_id: 30,
    created_at: null,
    updated_at: null
  },
  {
    id: 297,
    title: "Instala\u00e7\u00e3o ou Remodela\u00e7\u00e3o de Gradeamento",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 298,
    title: "Instala\u00e7\u00e3o ou Repara\u00e7\u00e3o de Port\u00f5es",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 62,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o da Canaliza\u00e7\u00e3o Exterior",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 63,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Bomba de \u00c1gua",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 52,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Calhas",
    sub_group_id: 11,
    created_at: null,
    updated_at: null
  },
  {
    id: 81,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Cortinas",
    sub_group_id: 14,
    created_at: null,
    updated_at: null
  },
  {
    id: 48,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Esquentador",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 331,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Exaustor de Cozinha",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 118,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Persianas",
    sub_group_id: 23,
    created_at: null,
    updated_at: null
  },
  {
    id: 299,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Port\u00e3o de Garagem",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 303,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Telhado",
    sub_group_id: 51,
    created_at: null,
    updated_at: null
  },
  {
    id: 332,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Ventilador de Casa de Banho",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 290,
    title:
      "Instala\u00e7\u00e3o, Repara\u00e7\u00e3o ou Remo\u00e7\u00e3o de Revestimento de Parede",
    sub_group_id: 48,
    created_at: null,
    updated_at: null
  },
  {
    id: 472,
    title: "Interpreta\u00e7\u00e3o de Linguagem Jur\u00eddica",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 451,
    title: "Introdu\u00e7\u00e3o de Dados",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 477,
    title: "Investiga\u00e7\u00e3o Paranormal",
    sub_group_id: 91,
    created_at: null,
    updated_at: null
  },
  {
    id: 478,
    title: "Investiga\u00e7\u00e3o Privada",
    sub_group_id: 91,
    created_at: null,
    updated_at: null
  },
  {
    id: 143,
    title: "Isolamentos",
    sub_group_id: 30,
    created_at: null,
    updated_at: null
  },
  {
    id: 159,
    title: "Jardinagem",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 490,
    title: "Joalharia Personalizada",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 182,
    title: "Lavagem \u00e0 Press\u00e3o",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 178,
    title: "Lavandarias",
    sub_group_id: 34,
    created_at: null,
    updated_at: null
  },
  {
    id: 271,
    title: "Levantamento de Alicerces",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 183,
    title: "Limpeza Ap\u00f3s Mudan\u00e7as",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 184,
    title: "Limpeza Geral",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 185,
    title: "Limpeza a Fundo",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 186,
    title: "Limpeza a Vapor",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 187,
    title: "Limpeza da Casa (Recorrente)",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 188,
    title: "Limpeza da Casa (Uma Vez)",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 189,
    title: "Limpeza de Alcatifa",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 190,
    title: "Limpeza de Apartamento",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 191,
    title: "Limpeza de Azulejos e Juntas",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 192,
    title: "Limpeza de Colch\u00e3o",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 193,
    title: "Limpeza de Espa\u00e7o Comercial",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 160,
    title: "Limpeza de Folhas (Pontual)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 161,
    title: "Limpeza de Folhas (Recorrente)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 194,
    title: "Limpeza de Janelas",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 180,
    title: "Limpeza de Lareiras e Chamin\u00e9s",
    sub_group_id: 35,
    created_at: null,
    updated_at: null
  },
  {
    id: 195,
    title: "Limpeza de Propriedade",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 196,
    title: "Limpeza de Soalho",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 197,
    title: "Limpeza de Tapete",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 198,
    title: "Limpeza de Telhado",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 333,
    title: "Limpeza de Tubagem de Ventila\u00e7\u00e3o",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 199,
    title: "Limpeza e Manuten\u00e7\u00e3o de Calhas",
    sub_group_id: 36,
    created_at: null,
    updated_at: null
  },
  {
    id: 210,
    title: "Limpeza ou Inspe\u00e7\u00e3o de Painel Solar",
    sub_group_id: 40,
    created_at: null,
    updated_at: null
  },
  {
    id: 257,
    title: "Limpeza ou Manuten\u00e7\u00e3o de Piscina",
    sub_group_id: 46,
    created_at: null,
    updated_at: null
  },
  {
    id: 16,
    title: "Loja",
    sub_group_id: 3,
    created_at: null,
    updated_at: null
  },
  {
    id: 334,
    title: "Manuten\u00e7\u00e3o de Ar Condicionado",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 162,
    title: "Manuten\u00e7\u00e3o de Arbustos",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 219,
    title: "Manuten\u00e7\u00e3o de Sistema de Rega Gota a Gota",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 127,
    title: "Manuten\u00e7\u00e3o e Repara\u00e7\u00e3o de Cerca",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 128,
    title:
      "Manuten\u00e7\u00e3o e Repara\u00e7\u00e3o de Cobertura de P\u00e1tio",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 307,
    title: "Manuten\u00e7\u00e3o e Repara\u00e7\u00e3o de Toldos",
    sub_group_id: 52,
    created_at: null,
    updated_at: null
  },
  {
    id: 131,
    title: "Manuten\u00e7\u00e3o ou Repara\u00e7\u00e3o de Fog\u00e3o e Forno",
    sub_group_id: 25,
    created_at: null,
    updated_at: null
  },
  {
    id: 133,
    title: "Manuten\u00e7\u00e3o ou Repara\u00e7\u00e3o de Frigor\u00edfico",
    sub_group_id: 26,
    created_at: null,
    updated_at: null
  },
  {
    id: 359,
    title: "Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 360,
    title: "Marketing Digital",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 374,
    title: "Massagem para Animais de Estima\u00e7\u00e3o",
    sub_group_id: 71,
    created_at: null,
    updated_at: null
  },
  {
    id: 473,
    title: "Media\u00e7\u00e3o de Conflitos",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 23,
    title: "Misto",
    sub_group_id: 5,
    created_at: null,
    updated_at: null
  },
  {
    id: 272,
    title: "Modifica\u00e7\u00f5es para Pessoas Idosas",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 273,
    title: "Modifica\u00e7\u00f5es para Pessoas Incapacitadas",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 36,
    title: "Montagem de Ber\u00e7o",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 37,
    title: "Montagem de C\u00f3moda",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 38,
    title: "Montagem de Equipamento Desportivo",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 39,
    title: "Montagem de Mobili\u00e1rio IKEA",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 129,
    title: "Montagem de Mobili\u00e1rio ou Equipamento Exterior",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 40,
    title: "Montagem de Mob\u00edlia",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 41,
    title: "Montagem de Secret\u00e1ria",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 42,
    title: "Montagem de TV",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 130,
    title: "Montagem de Terra\u00e7o",
    sub_group_id: 24,
    created_at: null,
    updated_at: null
  },
  {
    id: 15,
    title: "Moradia > T7",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 8,
    title: "Moradia T0",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 9,
    title: "Moradia T1",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 10,
    title: "Moradia T2",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 11,
    title: "Moradia T3",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 12,
    title: "Moradia T4",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 13,
    title: "Moradia T5",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 14,
    title: "Moradia T6",
    sub_group_id: 2,
    created_at: null,
    updated_at: null
  },
  {
    id: 201,
    title: "Mudan\u00e7a Local (At\u00e9 50 Km)",
    sub_group_id: 37,
    created_at: null,
    updated_at: null
  },
  {
    id: 202,
    title: "Mudan\u00e7a de Longa Dist\u00e2ncia",
    sub_group_id: 37,
    created_at: null,
    updated_at: null
  },
  {
    id: 203,
    title: "Mudan\u00e7a de Piano",
    sub_group_id: 37,
    created_at: null,
    updated_at: null
  },
  {
    id: 423,
    title: "Mudar Pneus",
    sub_group_id: 83,
    created_at: null,
    updated_at: null
  },
  {
    id: 31,
    title: "Nivelamento de Superf\u00edcies em Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null
  },
  {
    id: 220,
    title:
      "Nivela\u00e7\u00e3o e Gradua\u00e7\u00e3o de Terreno - Grande Dimens\u00e3o (mais de 1 hectar)",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 221,
    title:
      "Nivela\u00e7\u00e3o e Gradua\u00e7\u00e3o de Terreno - Pequena Dimens\u00e3o (menos de 1 hectar)",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 416,
    title: "Not\u00e1rio",
    sub_group_id: 80,
    created_at: null,
    updated_at: null
  },
  {
    id: 274,
    title: "Obras de Remodela\u00e7\u00e3o",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 275,
    title: "Obras em Casa",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 18,
    title: "Oficina",
    sub_group_id: 3,
    created_at: null,
    updated_at: null
  },
  {
    id: 424,
    title: "Oficinas de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null
  },
  {
    id: 361,
    title: "Otimiza\u00e7\u00e3o de Motores de Busca (SEO)",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 222,
    title: "Paisagismo Exterior",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 452,
    title: "Pesquisa na Internet",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 420,
    title: "Pet Sitting",
    sub_group_id: 81,
    created_at: null,
    updated_at: null
  },
  {
    id: 64,
    title: "Pichelaria",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 242,
    title: "Pintura Exterior",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 243,
    title: "Pintura de Alpendre",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 244,
    title: "Pintura de Arm\u00e1rios",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 425,
    title: "Pintura de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null
  },
  {
    id: 245,
    title: "Pintura de Casas",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 246,
    title: "Pintura de Interiores",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 247,
    title: "Pintura de Portas",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 248,
    title: "Pintura de Pr\u00e9dios",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 249,
    title: "Pintura de P\u00e1tio ou Alpendre",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 250,
    title: "Pintura ou Revestimento de Pavimento",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 163,
    title: "Planta\u00e7\u00e3o de Arbustos",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 164,
    title: "Planta\u00e7\u00e3o de \u00c1rvores",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 165,
    title: "Poda e Manuten\u00e7\u00e3o de \u00c1rvores",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 151,
    title: "Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 368,
    title:
      "Prepara\u00e7\u00e3o de Declara\u00e7\u00e3o de Impostos Individual",
    sub_group_id: 70,
    created_at: null,
    updated_at: null
  },
  {
    id: 369,
    title: "Prepara\u00e7\u00e3o de Declara\u00e7\u00f5es de Impostos",
    sub_group_id: 70,
    created_at: null,
    updated_at: null
  },
  {
    id: 370,
    title:
      "Prepara\u00e7\u00e3o de Declara\u00e7\u00f5es de Impostos de Empresas",
    sub_group_id: 70,
    created_at: null,
    updated_at: null
  },
  {
    id: 474,
    title: "Prepara\u00e7\u00e3o de Documenta\u00e7\u00e3o Legal",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 65,
    title: "Press\u00e3o Baixa da \u00c1gua",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 479,
    title: "Preven\u00e7\u00e3o e Resolu\u00e7\u00e3o de Dist\u00farbios",
    sub_group_id: 92,
    created_at: null,
    updated_at: null
  },
  {
    id: 104,
    title: "Problemas El\u00e9tricos e de Cabos",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 350,
    title: "Profissionais Financeiros e de Planeamento",
    sub_group_id: 66,
    created_at: null,
    updated_at: null
  },
  {
    id: 503,
    title: "Programa\u00e7\u00e3o Web",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 276,
    title: "Prote\u00e7\u00e3o do Espa\u00e7o para Crian\u00e7as",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 362,
    title: "Publicidade",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 231,
    title: "Reboco",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 365,
    title: "Recrutamento",
    sub_group_id: 69,
    created_at: null,
    updated_at: null
  },
  {
    id: 366,
    title: "Recursos Humanos e Gest\u00e3o de Sal\u00e1rios",
    sub_group_id: 69,
    created_at: null,
    updated_at: null
  },
  {
    id: 453,
    title: "Rela\u00e7\u00f5es P\u00fablicas",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 277,
    title: "Remodela\u00e7\u00e3o da Casa",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 77,
    title: "Remodela\u00e7\u00e3o de Arm\u00e1rios",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 278,
    title: "Remodela\u00e7\u00e3o de Casa de Banho",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 279,
    title: "Remodela\u00e7\u00e3o de Caves",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 280,
    title: "Remodela\u00e7\u00e3o de Cozinhas",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 281,
    title: "Remodela\u00e7\u00e3o de Efici\u00eancia Energ\u00e9tica",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 282,
    title: "Remodela\u00e7\u00e3o de P\u00e1tio",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 283,
    title: "Remodela\u00e7\u00e3o de Quarto",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 284,
    title: "Remodela\u00e7\u00e3o de S\u00f3t\u00e3o",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 285,
    title: "Remodela\u00e7\u00e3o de Varanda",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 286,
    title: "Remodela\u00e7\u00e3o ou Constru\u00e7\u00e3o de Cozinha Exterior",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 94,
    title: "Remo\u00e7\u00e3o de Animais Selvagens",
    sub_group_id: 18,
    created_at: null,
    updated_at: null
  },
  {
    id: 166,
    title: "Remo\u00e7\u00e3o de Arbustos",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 32,
    title: "Remo\u00e7\u00e3o de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null
  },
  {
    id: 167,
    title: "Remo\u00e7\u00e3o de Ervas Daninhas",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 225,
    title: "Remo\u00e7\u00e3o de Papel de Parede",
    sub_group_id: 42,
    created_at: null,
    updated_at: null
  },
  {
    id: 287,
    title: "Remo\u00e7\u00e3o de Parede Interior",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 152,
    title: "Remo\u00e7\u00e3o de Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 232,
    title: "Remo\u00e7\u00e3o de Textura Irregular",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 251,
    title: "Remo\u00e7\u00e3o de Tinta",
    sub_group_id: 45,
    created_at: null,
    updated_at: null
  },
  {
    id: 430,
    title: "Remo\u00e7\u00e3o de V\u00edrus",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 116,
    title: "Reparador de Estofos",
    sub_group_id: 22,
    created_at: null,
    updated_at: null
  },
  {
    id: 288,
    title: "Repara\u00e7\u00e3o de Alpendre",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 326,
    title: "Repara\u00e7\u00e3o de Aquecedores El\u00e9ctricos ou a G\u00e1s",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 327,
    title: "Repara\u00e7\u00e3o de Aquecimento Central",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 335,
    title: "Repara\u00e7\u00e3o de Ar Condicionado/Ventila\u00e7\u00e3o",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 78,
    title: "Repara\u00e7\u00e3o de Arm\u00e1rios",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 426,
    title: "Repara\u00e7\u00e3o de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null
  },
  {
    id: 174,
    title: "Repara\u00e7\u00e3o de Azulejos",
    sub_group_id: 33,
    created_at: null,
    updated_at: null
  },
  {
    id: 66,
    title: "Repara\u00e7\u00e3o de Banheira e Chuveiro",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 441,
    title: "Repara\u00e7\u00e3o de Caixas ATM",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 49,
    title: "Repara\u00e7\u00e3o de Caldeiras",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 53,
    title: "Repara\u00e7\u00e3o de Calhas",
    sub_group_id: 11,
    created_at: null,
    updated_at: null
  },
  {
    id: 431,
    title: "Repara\u00e7\u00e3o de Computador Apple",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 432,
    title: "Repara\u00e7\u00e3o de Computador Pessoal",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 433,
    title: "Repara\u00e7\u00e3o de Computadores",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 82,
    title: "Repara\u00e7\u00e3o de Cortinas",
    sub_group_id: 14,
    created_at: null,
    updated_at: null
  },
  {
    id: 105,
    title: "Repara\u00e7\u00e3o de Disjuntor ou Caixa de Fus\u00edveis",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 110,
    title: "Repara\u00e7\u00e3o de Eletrodom\u00e9sticos",
    sub_group_id: 20,
    created_at: null,
    updated_at: null
  },
  {
    id: 442,
    title: "Repara\u00e7\u00e3o de Equipamento Desportivo",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 443,
    title: "Repara\u00e7\u00e3o de Equipamento para Crian\u00e7as",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 233,
    title: "Repara\u00e7\u00e3o de Escadas e Escadarias",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 50,
    title: "Repara\u00e7\u00e3o de Esquentador",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 119,
    title: "Repara\u00e7\u00e3o de Estores",
    sub_group_id: 23,
    created_at: null,
    updated_at: null
  },
  {
    id: 437,
    title: "Repara\u00e7\u00e3o de Fotocopiadora",
    sub_group_id: 85,
    created_at: null,
    updated_at: null
  },
  {
    id: 438,
    title: "Repara\u00e7\u00e3o de Impressora",
    sub_group_id: 85,
    created_at: null,
    updated_at: null
  },
  {
    id: 439,
    title: "Repara\u00e7\u00e3o de Impressora e Fotocopiadora",
    sub_group_id: 85,
    created_at: null,
    updated_at: null
  },
  {
    id: 106,
    title: "Repara\u00e7\u00e3o de Interruptores e Tomadas",
    sub_group_id: 19,
    created_at: null,
    updated_at: null
  },
  {
    id: 153,
    title: "Repara\u00e7\u00e3o de Janelas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 67,
    title: "Repara\u00e7\u00e3o de Lavat\u00f3rio e Torneira",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 444,
    title: "Repara\u00e7\u00e3o de Mesas de Bilhar",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 43,
    title: "Repara\u00e7\u00e3o de Mob\u00edlia",
    sub_group_id: 9,
    created_at: null,
    updated_at: null
  },
  {
    id: 427,
    title: "Repara\u00e7\u00e3o de Motas",
    sub_group_id: 83,
    created_at: null,
    updated_at: null
  },
  {
    id: 445,
    title: "Repara\u00e7\u00e3o de M\u00e1quinas de Constru\u00e7\u00e3o",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 446,
    title: "Repara\u00e7\u00e3o de M\u00e1quinas de Venda Autom\u00e1tica",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 211,
    title: "Repara\u00e7\u00e3o de Painel Solar",
    sub_group_id: 40,
    created_at: null,
    updated_at: null
  },
  {
    id: 120,
    title: "Repara\u00e7\u00e3o de Persianas",
    sub_group_id: 23,
    created_at: null,
    updated_at: null
  },
  {
    id: 258,
    title: "Repara\u00e7\u00e3o de Piscina",
    sub_group_id: 46,
    created_at: null,
    updated_at: null
  },
  {
    id: 300,
    title: "Repara\u00e7\u00e3o de Porta",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 154,
    title: "Repara\u00e7\u00e3o de Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null
  },
  {
    id: 301,
    title: "Repara\u00e7\u00e3o de Port\u00e3o de Garagem",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 336,
    title: "Repara\u00e7\u00e3o de Recuperador de Calor",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 337,
    title: "Repara\u00e7\u00e3o de Salamandra",
    sub_group_id: 60,
    created_at: null,
    updated_at: null
  },
  {
    id: 68,
    title: "Repara\u00e7\u00e3o de Sanita",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 406,
    title: "Repara\u00e7\u00e3o de Terminais de Pagamento",
    sub_group_id: 76,
    created_at: null,
    updated_at: null
  },
  {
    id: 69,
    title: "Repara\u00e7\u00e3o de Tubos de Canaliza\u00e7\u00e3o",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 289,
    title: "Repara\u00e7\u00e3o de Varanda",
    sub_group_id: 47,
    created_at: null,
    updated_at: null
  },
  {
    id: 448,
    title: "Repara\u00e7\u00e3o e Assist. T\u00e9cnica - Smartphones e Tablets",
    sub_group_id: 87,
    created_at: null,
    updated_at: null
  },
  {
    id: 449,
    title: "Repara\u00e7\u00e3o e Assist. T\u00e9cnica - TV",
    sub_group_id: 88,
    created_at: null,
    updated_at: null
  },
  {
    id: 136,
    title: "Repara\u00e7\u00e3o e Inspe\u00e7\u00e3o de G\u00e1s",
    sub_group_id: 28,
    created_at: null,
    updated_at: null
  },
  {
    id: 113,
    title: "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Alvenaria",
    sub_group_id: 21,
    created_at: null,
    updated_at: null
  },
  {
    id: 33,
    title: "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Asfalto",
    sub_group_id: 8,
    created_at: null,
    updated_at: null
  },
  {
    id: 34,
    title: "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null
  },
  {
    id: 223,
    title:
      "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Sistema de Irriga\u00e7\u00e3o",
    sub_group_id: 41,
    created_at: null,
    updated_at: null
  },
  {
    id: 234,
    title: "Repara\u00e7\u00e3o e Texturiza\u00e7\u00e3o de Paredes de Pladur",
    sub_group_id: 43,
    created_at: null,
    updated_at: null
  },
  {
    id: 51,
    title: "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Caldeira",
    sub_group_id: 10,
    created_at: null,
    updated_at: null
  },
  {
    id: 70,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Canaliza\u00e7\u00e3o Exterior",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 71,
    title: "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Fossa S\u00e9ptica",
    sub_group_id: 12,
    created_at: null,
    updated_at: null
  },
  {
    id: 206,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de M\u00e1quina de Lavar Loi\u00e7a",
    sub_group_id: 38,
    created_at: null,
    updated_at: null
  },
  {
    id: 208,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de M\u00e1quina de Lavar Roupa",
    sub_group_id: 39,
    created_at: null,
    updated_at: null
  },
  {
    id: 328,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Sistemas de Aquecimento",
    sub_group_id: 59,
    created_at: null,
    updated_at: null
  },
  {
    id: 304,
    title: "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Telhado",
    sub_group_id: 51,
    created_at: null,
    updated_at: null
  },
  {
    id: 79,
    title: "Restauro de M\u00f3veis",
    sub_group_id: 13,
    created_at: null,
    updated_at: null
  },
  {
    id: 241,
    title: "Retoque de Pavimento em Madeira",
    sub_group_id: 44,
    created_at: null,
    updated_at: null
  },
  {
    id: 421,
    title: "Retratos Art\u00edsticos",
    sub_group_id: 82,
    created_at: null,
    updated_at: null
  },
  {
    id: 491,
    title: "Revestimento com Tinta em P\u00f3",
    sub_group_id: 93,
    created_at: null,
    updated_at: null
  },
  {
    id: 175,
    title: "Revestimento de Casa de Banho",
    sub_group_id: 33,
    created_at: null,
    updated_at: null
  },
  {
    id: 176,
    title: "Revestimento de Cozinha",
    sub_group_id: 33,
    created_at: null,
    updated_at: null
  },
  {
    id: 291,
    title: "Revestimento de Parede em Madeira",
    sub_group_id: 48,
    created_at: null,
    updated_at: null
  },
  {
    id: 292,
    title: "Revestimento de Parede em Metal",
    sub_group_id: 48,
    created_at: null,
    updated_at: null
  },
  {
    id: 177,
    title: "Revestimento de Pavimento",
    sub_group_id: 33,
    created_at: null,
    updated_at: null
  },
  {
    id: 428,
    title: "Revis\u00e3o Autom\u00f3vel",
    sub_group_id: 83,
    created_at: null,
    updated_at: null
  },
  {
    id: 21,
    title: "R\u00fastico",
    sub_group_id: 5,
    created_at: null,
    updated_at: null
  },
  {
    id: 363,
    title: "SMS Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 480,
    title: "Seguran\u00e7a",
    sub_group_id: 92,
    created_at: null,
    updated_at: null
  },
  {
    id: 481,
    title: "Seguran\u00e7a para Eventos",
    sub_group_id: 92,
    created_at: null,
    updated_at: null
  },
  {
    id: 168,
    title: "Semeadura",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 302,
    title: "Serralharia",
    sub_group_id: 50,
    created_at: null,
    updated_at: null
  },
  {
    id: 454,
    title: "Servi\u00e7o de Apoio ao Cliente",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 24,
    title: "Servi\u00e7o de Bobcat",
    sub_group_id: 6,
    created_at: null,
    updated_at: null
  },
  {
    id: 482,
    title: "Servi\u00e7o de Guarda Costas",
    sub_group_id: 92,
    created_at: null,
    updated_at: null
  },
  {
    id: 455,
    title:
      "Servi\u00e7o de M\u00e1quinas de Controlo Num\u00e9rico Computarizado",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 434,
    title: "Servi\u00e7o de Recupera\u00e7\u00e3o de Dados",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 25,
    title: "Servi\u00e7o de Retroescavadora",
    sub_group_id: 6,
    created_at: null,
    updated_at: null
  },
  {
    id: 435,
    title: "Servi\u00e7o de Suporte T\u00e9cnico",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 450,
    title: "Servi\u00e7os Empresariais",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 179,
    title: "Servi\u00e7os de Engomadoria",
    sub_group_id: 34,
    created_at: null,
    updated_at: null
  },
  {
    id: 412,
    title: "Servi\u00e7os de Impress\u00e3o",
    sub_group_id: 78,
    created_at: null,
    updated_at: null
  },
  {
    id: 436,
    title:
      "Servi\u00e7os de Recupera\u00e7\u00e3o e Reposi\u00e7\u00e3o de Dados",
    sub_group_id: 84,
    created_at: null,
    updated_at: null
  },
  {
    id: 407,
    title: "Sistemas Telef\u00f3nicos",
    sub_group_id: 76,
    created_at: null,
    updated_at: null
  },
  {
    id: 364,
    title: "Social Media Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null
  },
  {
    id: 475,
    title: "Solicitadores",
    sub_group_id: 90,
    created_at: null,
    updated_at: null
  },
  {
    id: 114,
    title: "Supervis\u00e3o de Obras",
    sub_group_id: 21,
    created_at: null,
    updated_at: null
  },
  {
    id: 456,
    title: "Suporte Administrativo",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 408,
    title: "Suporte de Redes e Sistemas",
    sub_group_id: 76,
    created_at: null,
    updated_at: null
  },
  {
    id: 457,
    title: "Telemarketing e Televendas",
    sub_group_id: 89,
    created_at: null,
    updated_at: null
  },
  {
    id: 305,
    title: "Telhado ou Cobertura",
    sub_group_id: 51,
    created_at: null,
    updated_at: null
  },
  {
    id: 413,
    title: "Tipografias",
    sub_group_id: 78,
    created_at: null,
    updated_at: null
  },
  {
    id: 308,
    title: "Topografia",
    sub_group_id: 53,
    created_at: null,
    updated_at: null
  },
  {
    id: 387,
    title: "Tradu\u00e7\u00e3o",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 388,
    title: "Tradu\u00e7\u00e3o de Alem\u00e3o",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 389,
    title: "Tradu\u00e7\u00e3o de Chin\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 390,
    title: "Tradu\u00e7\u00e3o de Espanhol",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 391,
    title: "Tradu\u00e7\u00e3o de Franc\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 392,
    title: "Tradu\u00e7\u00e3o de Grego",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 393,
    title: "Tradu\u00e7\u00e3o de Holand\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 394,
    title: "Tradu\u00e7\u00e3o de Ingl\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 395,
    title: "Tradu\u00e7\u00e3o de Italiano",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 396,
    title: "Tradu\u00e7\u00e3o de Japon\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 397,
    title: "Tradu\u00e7\u00e3o de Mandarim",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 398,
    title: "Tradu\u00e7\u00e3o de Russo",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 399,
    title: "Tradu\u00e7\u00e3o de \u00c1rabe",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 400,
    title: "Transcri\u00e7\u00e3o",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 401,
    title: "Transcri\u00e7\u00e3o M\u00e9dica",
    sub_group_id: 74,
    created_at: null,
    updated_at: null
  },
  {
    id: 204,
    title: "Transporte de M\u00f3veis",
    sub_group_id: 37,
    created_at: null,
    updated_at: null
  },
  {
    id: 169,
    title: "Tratamento de Relvado",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 170,
    title: "Tratamento de Relvado (Recorrente)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 492,
    title: "Treino de C\u00e3es",
    sub_group_id: 94,
    created_at: null,
    updated_at: null
  },
  {
    id: 171,
    title: "Tritura\u00e7\u00e3o e Remo\u00e7\u00e3o de Tronco de \u00c1rvore",
    sub_group_id: 32,
    created_at: null,
    updated_at: null
  },
  {
    id: 447,
    title: "T\u00e9cnico de Aqu\u00e1rios",
    sub_group_id: 86,
    created_at: null,
    updated_at: null
  },
  {
    id: 22,
    title: "Urbano",
    sub_group_id: 5,
    created_at: null,
    updated_at: null
  },
  {
    id: 88,
    title: "Valoriza\u00e7\u00e3o Imobili\u00e1ria",
    sub_group_id: 17,
    created_at: null,
    updated_at: null
  },
  {
    id: 493,
    title: "Veterin\u00e1rios",
    sub_group_id: 95,
    created_at: null,
    updated_at: null
  },
  {
    id: 309,
    title: "Vidraceiro",
    sub_group_id: 54,
    created_at: null,
    updated_at: null
  },
  {
    id: 310,
    title: "Vitrais",
    sub_group_id: 54,
    created_at: null,
    updated_at: null
  },
  {
    id: 504,
    title: "Web Design",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  },
  {
    id: 505,
    title: "Web Development",
    sub_group_id: 96,
    created_at: null,
    updated_at: null
  }
];

export const group1 = [
  {
    id: 7,
    title: "Apartamento Duplex",
    sub_group_id: 1,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 1,
    title: "Apartamento T0",
    sub_group_id: 1,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 2,
    title: "Apartamento T1",
    sub_group_id: 1,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 3,
    title: "Apartamento T2",
    sub_group_id: 1,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 4,
    title: "Apartamento T3",
    sub_group_id: 1,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 5,
    title: "Apartamento T4",
    sub_group_id: 1,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 6,
    title: "Apartamento T5",
    sub_group_id: 1,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 19,
    title: "Armaz\u00e9m",
    sub_group_id: 3,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 17,
    title: "Escrit\u00f3rio",
    sub_group_id: 3,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 20,
    title: "Industrial",
    sub_group_id: 3,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 16,
    title: "Loja",
    sub_group_id: 3,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 23,
    title: "Misto",
    sub_group_id: 5,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 15,
    title: "Moradia > T7",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 8,
    title: "Moradia T0",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 9,
    title: "Moradia T1",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 10,
    title: "Moradia T2",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 11,
    title: "Moradia T3",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 12,
    title: "Moradia T4",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 13,
    title: "Moradia T5",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 14,
    title: "Moradia T6",
    sub_group_id: 2,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 18,
    title: "Oficina",
    sub_group_id: 3,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 21,
    title: "R\u00fastico",
    sub_group_id: 5,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  },
  {
    id: 22,
    title: "Urbano",
    sub_group_id: 5,
    created_at: null,
    updated_at: null,
    main_group_id: 1
  }
];

export const group2 = [
  {
    id: 144,
    title: "Acabamento de Janelas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 111,
    title: "Alvenaria",
    sub_group_id: 21,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 107,
    title: "Antena Parab\u00f3lica",
    sub_group_id: 20,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 226,
    title: "Aplica\u00e7\u00e3o de Estuque",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 89,
    title: "Aplica\u00e7\u00e3o de Pesticida no Exterior",
    sub_group_id: 18,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 72,
    title: "Arm\u00e1rios de Cozinha",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 73,
    title: "Arm\u00e1rios de Roupa",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 26,
    title: "Arquitetura",
    sub_group_id: 7,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 27,
    title: "Arquitetura de interiores",
    sub_group_id: 7,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 95,
    title: "Automa\u00e7\u00e3o Residencial e Dom\u00f3tica",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 112,
    title: "Calafetagem",
    sub_group_id: 21,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 54,
    title: "Canaliza\u00e7\u00e3o",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 55,
    title: "Canos Furados ou Problemas com Torneiras",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 74,
    title: "Carpintaria Geral",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 75,
    title: "Carpintaria de Obras",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 145,
    title: "Clarab\u00f3ias",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 212,
    title: "Coloca\u00e7\u00e3o de Pedra",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 259,
    title: "Constru\u00e7\u00e3o Civil",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 260,
    title: "Constru\u00e7\u00e3o de Casa Nova",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 121,
    title: "Constru\u00e7\u00e3o de Equipamento de Divers\u00e3o Infantil",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 261,
    title: "Constru\u00e7\u00e3o de Parede Interior",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 252,
    title: "Constru\u00e7\u00e3o de Piscina Abaixo do Solo",
    sub_group_id: 46,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 122,
    title: "Constru\u00e7\u00e3o de Po\u00e7o",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 262,
    title: "Constru\u00e7\u00e3o de P\u00e1tio",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 263,
    title: "Constru\u00e7\u00e3o de Teto Falso",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 227,
    title:
      "Constru\u00e7\u00e3o ou Remodela\u00e7\u00e3o de Escadas e Escadarias",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 90,
    title: "Controlo de Pragas",
    sub_group_id: 18,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 28,
    title: "Corte de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 155,
    title: "Corte e Apara\u00e7\u00e3o de Relvado",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 156,
    title: "Corte e Apara\u00e7\u00e3o de Relvado (Recorrente)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 80,
    title: "Decora\u00e7\u00e3o de Interiores",
    sub_group_id: 14,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 157,
    title: "Delimita\u00e7\u00e3o de Relvados",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 264,
    title: "Demoli\u00e7\u00e3o de Constru\u00e7\u00f5es",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 83,
    title: "Desenho T\u00e9cnico",
    sub_group_id: 15,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 84,
    title: "Desenho de Engenharia",
    sub_group_id: 15,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 87,
    title: "Design de Interiores",
    sub_group_id: 17,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 213,
    title: "Design de Paisagismo de Exteriores",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 265,
    title: "Divis\u00e3o de Quarto",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 85,
    title: "Drenagem Lenta ou Entupida",
    sub_group_id: 16,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 96,
    title: "Eletricistas",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 91,
    title: "Elimina\u00e7\u00e3o de Animais e Roedores",
    sub_group_id: 18,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 200,
    title: "Embalar e Desembalar M\u00f3veis",
    sub_group_id: 37,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 86,
    title: "Empresas de Desentupimentos",
    sub_group_id: 16,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 92,
    title: "Empresas de Desinfesta\u00e7\u00e3o",
    sub_group_id: 18,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 115,
    title: "Estofador",
    sub_group_id: 22,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 214,
    title: "Estufas",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 266,
    title: "Extens\u00e3o de Quarto",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 93,
    title: "Exterm\u00ednio de Percevejos",
    sub_group_id: 18,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 158,
    title: "Fertiliza\u00e7\u00e3o",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 97,
    title: "Fia\u00e7\u00e3o",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 134,
    title: "Gest\u00e3o de Condom\u00ednios",
    sub_group_id: 27,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 137,
    title: "Ilumina\u00e7\u00e3o Exterior",
    sub_group_id: 29,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 141,
    title: "Impermeabiliza\u00e7\u00e3o da Casa",
    sub_group_id: 30,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 267,
    title: "Impermeabiliza\u00e7\u00e3o de Alpendre",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 228,
    title: "Insonoriza\u00e7\u00e3o",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 181,
    title: "Inspe\u00e7\u00e3o e Remo\u00e7\u00e3o de Bolor",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 44,
    title: "Inspe\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Caldeira a Vapor",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 45,
    title: "Inspe\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Esquentador",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 293,
    title: "Instala\u00e7\u00e3o de Alarme e Seguran\u00e7a Domicili\u00e1ria",
    sub_group_id: 49,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 268,
    title: "Instala\u00e7\u00e3o de Alicerces",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 269,
    title: "Instala\u00e7\u00e3o de Alpendres",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 76,
    title: "Instala\u00e7\u00e3o de Arm\u00e1rios Pr\u00e9-fabricados",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 29,
    title: "Instala\u00e7\u00e3o de Asfalto",
    sub_group_id: 8,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 108,
    title: "Instala\u00e7\u00e3o de Aspira\u00e7\u00e3o Central",
    sub_group_id: 20,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 172,
    title: "Instala\u00e7\u00e3o de Azulejos",
    sub_group_id: 33,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 173,
    title: "Instala\u00e7\u00e3o de Azulejos de Cer\u00e2mica ou Porcelana",
    sub_group_id: 33,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 35,
    title: "Instala\u00e7\u00e3o de Bancada de Cozinha",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 56,
    title: "Instala\u00e7\u00e3o de Banheira e Chuveiro",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 30,
    title: "Instala\u00e7\u00e3o de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 46,
    title: "Instala\u00e7\u00e3o de Caldeira",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 47,
    title: "Instala\u00e7\u00e3o de Caldeira a Vapor",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 138,
    title: "Instala\u00e7\u00e3o de Candeeiros",
    sub_group_id: 29,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 123,
    title: "Instala\u00e7\u00e3o de Cerca",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 124,
    title: "Instala\u00e7\u00e3o de Cerca para C\u00e3es",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 125,
    title: "Instala\u00e7\u00e3o de Cobertura de P\u00e1tio",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 98,
    title: "Instala\u00e7\u00e3o de Disjuntor ou Caixa de Fus\u00edveis",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 109,
    title: "Instala\u00e7\u00e3o de Eletrodom\u00e9sticos",
    sub_group_id: 20,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 229,
    title: "Instala\u00e7\u00e3o de Escadas",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 117,
    title: "Instala\u00e7\u00e3o de Estores",
    sub_group_id: 23,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 57,
    title: "Instala\u00e7\u00e3o de Fossa S\u00e9ptica",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 132,
    title: "Instala\u00e7\u00e3o de Frigor\u00edfico",
    sub_group_id: 26,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 99,
    title: "Instala\u00e7\u00e3o de Gerador",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 270,
    title: "Instala\u00e7\u00e3o de Ilha de Cozinha",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 139,
    title: "Instala\u00e7\u00e3o de Ilumina\u00e7\u00e3o",
    sub_group_id: 29,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 100,
    title: "Instala\u00e7\u00e3o de Interruptores e Tomadas",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 253,
    title: "Instala\u00e7\u00e3o de Jacuzzi e Spa",
    sub_group_id: 46,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 146,
    title: "Instala\u00e7\u00e3o de Janelas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 147,
    title: "Instala\u00e7\u00e3o de Janelas de Alum\u00ednio",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 148,
    title: "Instala\u00e7\u00e3o de Janelas de PVC",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 58,
    title: "Instala\u00e7\u00e3o de Lavat\u00f3rio e Torneira",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 101,
    title: "Instala\u00e7\u00e3o de L\u00e2mpada",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 149,
    title: "Instala\u00e7\u00e3o de Marquises",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 205,
    title: "Instala\u00e7\u00e3o de M\u00e1quina de Lavar Loi\u00e7a",
    sub_group_id: 38,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 207,
    title: "Instala\u00e7\u00e3o de M\u00e1quina de Lavar Roupa",
    sub_group_id: 39,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 209,
    title: "Instala\u00e7\u00e3o de Painel Solar",
    sub_group_id: 40,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 224,
    title: "Instala\u00e7\u00e3o de Papel de Parede",
    sub_group_id: 42,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 230,
    title: "Instala\u00e7\u00e3o de Paredes de Pladur",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 235,
    title: "Instala\u00e7\u00e3o de Pavimento Flutuante",
    sub_group_id: 44,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 236,
    title: "Instala\u00e7\u00e3o de Pavimento Vin\u00edlico ou Lin\u00f3leo",
    sub_group_id: 44,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 237,
    title: "Instala\u00e7\u00e3o de Pavimento em Bet\u00e3o",
    sub_group_id: 44,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 238,
    title: "Instala\u00e7\u00e3o de Pavimento em Madeira",
    sub_group_id: 44,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 239,
    title: "Instala\u00e7\u00e3o de Pavimento em Pedra ou Ladrilho",
    sub_group_id: 44,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 254,
    title: "Instala\u00e7\u00e3o de Piscina",
    sub_group_id: 46,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 255,
    title: "Instala\u00e7\u00e3o de Piscina Acima do Solo",
    sub_group_id: 46,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 240,
    title: "Instala\u00e7\u00e3o de Piso Aquecido",
    sub_group_id: 44,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 295,
    title: "Instala\u00e7\u00e3o de Porta para Animais de Estima\u00e7\u00e3o",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 150,
    title: "Instala\u00e7\u00e3o de Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 296,
    title: "Instala\u00e7\u00e3o de Portas",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 215,
    title: "Instala\u00e7\u00e3o de Relva Artificial",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 216,
    title: "Instala\u00e7\u00e3o de Relvado",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 59,
    title: "Instala\u00e7\u00e3o de Sanita",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 256,
    title: "Instala\u00e7\u00e3o de Sauna",
    sub_group_id: 46,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 217,
    title: "Instala\u00e7\u00e3o de Sistema de Irriga\u00e7\u00e3o",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 218,
    title: "Instala\u00e7\u00e3o de Sistema de Rega Gota a Gota",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 60,
    title: "Instala\u00e7\u00e3o de Sistema de Tratamento de \u00c1gua",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 126,
    title: "Instala\u00e7\u00e3o de Terra\u00e7o",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 306,
    title: "Instala\u00e7\u00e3o de Toldos",
    sub_group_id: 52,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 61,
    title: "Instala\u00e7\u00e3o de Tubos de Canaliza\u00e7\u00e3o",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 102,
    title: "Instala\u00e7\u00e3o de Ventoinha",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 140,
    title:
      "Instala\u00e7\u00e3o e Remo\u00e7\u00e3o de Ilumina\u00e7\u00f5es para Festividades",
    sub_group_id: 29,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 294,
    title:
      "Instala\u00e7\u00e3o e Repara\u00e7\u00e3o de C\u00e2maras de Vigil\u00e2ncia",
    sub_group_id: 49,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 103,
    title: "Instala\u00e7\u00e3o e Repara\u00e7\u00e3o de Intercomunicadores",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 135,
    title: "Instala\u00e7\u00e3o e Verifica\u00e7\u00e3o de G\u00e1s",
    sub_group_id: 28,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 142,
    title: "Instala\u00e7\u00e3o ou Atualiza\u00e7\u00e3o de Isolamento",
    sub_group_id: 30,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 297,
    title: "Instala\u00e7\u00e3o ou Remodela\u00e7\u00e3o de Gradeamento",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 298,
    title: "Instala\u00e7\u00e3o ou Repara\u00e7\u00e3o de Port\u00f5es",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 62,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o da Canaliza\u00e7\u00e3o Exterior",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 63,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Bomba de \u00c1gua",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 52,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Calhas",
    sub_group_id: 11,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 81,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Cortinas",
    sub_group_id: 14,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 48,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Esquentador",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 118,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Persianas",
    sub_group_id: 23,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 299,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Port\u00e3o de Garagem",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 303,
    title: "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Telhado",
    sub_group_id: 51,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 290,
    title:
      "Instala\u00e7\u00e3o, Repara\u00e7\u00e3o ou Remo\u00e7\u00e3o de Revestimento de Parede",
    sub_group_id: 48,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 143,
    title: "Isolamentos",
    sub_group_id: 30,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 159,
    title: "Jardinagem",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 182,
    title: "Lavagem \u00e0 Press\u00e3o",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 178,
    title: "Lavandarias",
    sub_group_id: 34,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 271,
    title: "Levantamento de Alicerces",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 183,
    title: "Limpeza Ap\u00f3s Mudan\u00e7as",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 184,
    title: "Limpeza Geral",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 185,
    title: "Limpeza a Fundo",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 186,
    title: "Limpeza a Vapor",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 187,
    title: "Limpeza da Casa (Recorrente)",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 188,
    title: "Limpeza da Casa (Uma Vez)",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 189,
    title: "Limpeza de Alcatifa",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 190,
    title: "Limpeza de Apartamento",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 191,
    title: "Limpeza de Azulejos e Juntas",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 192,
    title: "Limpeza de Colch\u00e3o",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 193,
    title: "Limpeza de Espa\u00e7o Comercial",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 160,
    title: "Limpeza de Folhas (Pontual)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 161,
    title: "Limpeza de Folhas (Recorrente)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 194,
    title: "Limpeza de Janelas",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 180,
    title: "Limpeza de Lareiras e Chamin\u00e9s",
    sub_group_id: 35,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 195,
    title: "Limpeza de Propriedade",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 196,
    title: "Limpeza de Soalho",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 197,
    title: "Limpeza de Tapete",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 198,
    title: "Limpeza de Telhado",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 199,
    title: "Limpeza e Manuten\u00e7\u00e3o de Calhas",
    sub_group_id: 36,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 210,
    title: "Limpeza ou Inspe\u00e7\u00e3o de Painel Solar",
    sub_group_id: 40,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 257,
    title: "Limpeza ou Manuten\u00e7\u00e3o de Piscina",
    sub_group_id: 46,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 162,
    title: "Manuten\u00e7\u00e3o de Arbustos",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 219,
    title: "Manuten\u00e7\u00e3o de Sistema de Rega Gota a Gota",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 127,
    title: "Manuten\u00e7\u00e3o e Repara\u00e7\u00e3o de Cerca",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 128,
    title:
      "Manuten\u00e7\u00e3o e Repara\u00e7\u00e3o de Cobertura de P\u00e1tio",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 307,
    title: "Manuten\u00e7\u00e3o e Repara\u00e7\u00e3o de Toldos",
    sub_group_id: 52,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 131,
    title: "Manuten\u00e7\u00e3o ou Repara\u00e7\u00e3o de Fog\u00e3o e Forno",
    sub_group_id: 25,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 133,
    title: "Manuten\u00e7\u00e3o ou Repara\u00e7\u00e3o de Frigor\u00edfico",
    sub_group_id: 26,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 272,
    title: "Modifica\u00e7\u00f5es para Pessoas Idosas",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 273,
    title: "Modifica\u00e7\u00f5es para Pessoas Incapacitadas",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 36,
    title: "Montagem de Ber\u00e7o",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 37,
    title: "Montagem de C\u00f3moda",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 38,
    title: "Montagem de Equipamento Desportivo",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 39,
    title: "Montagem de Mobili\u00e1rio IKEA",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 129,
    title: "Montagem de Mobili\u00e1rio ou Equipamento Exterior",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 40,
    title: "Montagem de Mob\u00edlia",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 41,
    title: "Montagem de Secret\u00e1ria",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 42,
    title: "Montagem de TV",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 130,
    title: "Montagem de Terra\u00e7o",
    sub_group_id: 24,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 201,
    title: "Mudan\u00e7a Local (At\u00e9 50 Km)",
    sub_group_id: 37,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 202,
    title: "Mudan\u00e7a de Longa Dist\u00e2ncia",
    sub_group_id: 37,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 203,
    title: "Mudan\u00e7a de Piano",
    sub_group_id: 37,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 31,
    title: "Nivelamento de Superf\u00edcies em Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 220,
    title:
      "Nivela\u00e7\u00e3o e Gradua\u00e7\u00e3o de Terreno - Grande Dimens\u00e3o (mais de 1 hectar)",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 221,
    title:
      "Nivela\u00e7\u00e3o e Gradua\u00e7\u00e3o de Terreno - Pequena Dimens\u00e3o (menos de 1 hectar)",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 274,
    title: "Obras de Remodela\u00e7\u00e3o",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 275,
    title: "Obras em Casa",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 222,
    title: "Paisagismo Exterior",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 64,
    title: "Pichelaria",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 242,
    title: "Pintura Exterior",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 243,
    title: "Pintura de Alpendre",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 244,
    title: "Pintura de Arm\u00e1rios",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 245,
    title: "Pintura de Casas",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 246,
    title: "Pintura de Interiores",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 247,
    title: "Pintura de Portas",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 248,
    title: "Pintura de Pr\u00e9dios",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 249,
    title: "Pintura de P\u00e1tio ou Alpendre",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 250,
    title: "Pintura ou Revestimento de Pavimento",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 163,
    title: "Planta\u00e7\u00e3o de Arbustos",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 164,
    title: "Planta\u00e7\u00e3o de \u00c1rvores",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 165,
    title: "Poda e Manuten\u00e7\u00e3o de \u00c1rvores",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 151,
    title: "Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 65,
    title: "Press\u00e3o Baixa da \u00c1gua",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 104,
    title: "Problemas El\u00e9tricos e de Cabos",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 276,
    title: "Prote\u00e7\u00e3o do Espa\u00e7o para Crian\u00e7as",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 231,
    title: "Reboco",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 277,
    title: "Remodela\u00e7\u00e3o da Casa",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 77,
    title: "Remodela\u00e7\u00e3o de Arm\u00e1rios",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 278,
    title: "Remodela\u00e7\u00e3o de Casa de Banho",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 279,
    title: "Remodela\u00e7\u00e3o de Caves",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 280,
    title: "Remodela\u00e7\u00e3o de Cozinhas",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 281,
    title: "Remodela\u00e7\u00e3o de Efici\u00eancia Energ\u00e9tica",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 282,
    title: "Remodela\u00e7\u00e3o de P\u00e1tio",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 283,
    title: "Remodela\u00e7\u00e3o de Quarto",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 284,
    title: "Remodela\u00e7\u00e3o de S\u00f3t\u00e3o",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 285,
    title: "Remodela\u00e7\u00e3o de Varanda",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 286,
    title: "Remodela\u00e7\u00e3o ou Constru\u00e7\u00e3o de Cozinha Exterior",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 94,
    title: "Remo\u00e7\u00e3o de Animais Selvagens",
    sub_group_id: 18,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 166,
    title: "Remo\u00e7\u00e3o de Arbustos",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 32,
    title: "Remo\u00e7\u00e3o de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 167,
    title: "Remo\u00e7\u00e3o de Ervas Daninhas",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 225,
    title: "Remo\u00e7\u00e3o de Papel de Parede",
    sub_group_id: 42,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 287,
    title: "Remo\u00e7\u00e3o de Parede Interior",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 152,
    title: "Remo\u00e7\u00e3o de Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 232,
    title: "Remo\u00e7\u00e3o de Textura Irregular",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 251,
    title: "Remo\u00e7\u00e3o de Tinta",
    sub_group_id: 45,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 116,
    title: "Reparador de Estofos",
    sub_group_id: 22,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 288,
    title: "Repara\u00e7\u00e3o de Alpendre",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 78,
    title: "Repara\u00e7\u00e3o de Arm\u00e1rios",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 174,
    title: "Repara\u00e7\u00e3o de Azulejos",
    sub_group_id: 33,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 66,
    title: "Repara\u00e7\u00e3o de Banheira e Chuveiro",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 49,
    title: "Repara\u00e7\u00e3o de Caldeiras",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 53,
    title: "Repara\u00e7\u00e3o de Calhas",
    sub_group_id: 11,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 82,
    title: "Repara\u00e7\u00e3o de Cortinas",
    sub_group_id: 14,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 105,
    title: "Repara\u00e7\u00e3o de Disjuntor ou Caixa de Fus\u00edveis",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 110,
    title: "Repara\u00e7\u00e3o de Eletrodom\u00e9sticos",
    sub_group_id: 20,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 233,
    title: "Repara\u00e7\u00e3o de Escadas e Escadarias",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 50,
    title: "Repara\u00e7\u00e3o de Esquentador",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 119,
    title: "Repara\u00e7\u00e3o de Estores",
    sub_group_id: 23,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 106,
    title: "Repara\u00e7\u00e3o de Interruptores e Tomadas",
    sub_group_id: 19,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 153,
    title: "Repara\u00e7\u00e3o de Janelas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 67,
    title: "Repara\u00e7\u00e3o de Lavat\u00f3rio e Torneira",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 43,
    title: "Repara\u00e7\u00e3o de Mob\u00edlia",
    sub_group_id: 9,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 211,
    title: "Repara\u00e7\u00e3o de Painel Solar",
    sub_group_id: 40,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 120,
    title: "Repara\u00e7\u00e3o de Persianas",
    sub_group_id: 23,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 258,
    title: "Repara\u00e7\u00e3o de Piscina",
    sub_group_id: 46,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 300,
    title: "Repara\u00e7\u00e3o de Porta",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 154,
    title: "Repara\u00e7\u00e3o de Portadas",
    sub_group_id: 31,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 301,
    title: "Repara\u00e7\u00e3o de Port\u00e3o de Garagem",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 68,
    title: "Repara\u00e7\u00e3o de Sanita",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 69,
    title: "Repara\u00e7\u00e3o de Tubos de Canaliza\u00e7\u00e3o",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 289,
    title: "Repara\u00e7\u00e3o de Varanda",
    sub_group_id: 47,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 136,
    title: "Repara\u00e7\u00e3o e Inspe\u00e7\u00e3o de G\u00e1s",
    sub_group_id: 28,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 113,
    title: "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Alvenaria",
    sub_group_id: 21,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 33,
    title: "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Asfalto",
    sub_group_id: 8,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 34,
    title: "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Bet\u00e3o",
    sub_group_id: 8,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 223,
    title:
      "Repara\u00e7\u00e3o e Manuten\u00e7\u00e3o de Sistema de Irriga\u00e7\u00e3o",
    sub_group_id: 41,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 234,
    title: "Repara\u00e7\u00e3o e Texturiza\u00e7\u00e3o de Paredes de Pladur",
    sub_group_id: 43,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 51,
    title: "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Caldeira",
    sub_group_id: 10,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 70,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Canaliza\u00e7\u00e3o Exterior",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 71,
    title: "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Fossa S\u00e9ptica",
    sub_group_id: 12,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 206,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de M\u00e1quina de Lavar Loi\u00e7a",
    sub_group_id: 38,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 208,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de M\u00e1quina de Lavar Roupa",
    sub_group_id: 39,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 304,
    title: "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Telhado",
    sub_group_id: 51,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 79,
    title: "Restauro de M\u00f3veis",
    sub_group_id: 13,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 241,
    title: "Retoque de Pavimento em Madeira",
    sub_group_id: 44,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 175,
    title: "Revestimento de Casa de Banho",
    sub_group_id: 33,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 176,
    title: "Revestimento de Cozinha",
    sub_group_id: 33,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 291,
    title: "Revestimento de Parede em Madeira",
    sub_group_id: 48,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 292,
    title: "Revestimento de Parede em Metal",
    sub_group_id: 48,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 177,
    title: "Revestimento de Pavimento",
    sub_group_id: 33,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 168,
    title: "Semeadura",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 302,
    title: "Serralharia",
    sub_group_id: 50,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 24,
    title: "Servi\u00e7o de Bobcat",
    sub_group_id: 6,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 25,
    title: "Servi\u00e7o de Retroescavadora",
    sub_group_id: 6,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 179,
    title: "Servi\u00e7os de Engomadoria",
    sub_group_id: 34,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 114,
    title: "Supervis\u00e3o de Obras",
    sub_group_id: 21,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 305,
    title: "Telhado ou Cobertura",
    sub_group_id: 51,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 308,
    title: "Topografia",
    sub_group_id: 53,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 204,
    title: "Transporte de M\u00f3veis",
    sub_group_id: 37,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 169,
    title: "Tratamento de Relvado",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 170,
    title: "Tratamento de Relvado (Recorrente)",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 171,
    title: "Tritura\u00e7\u00e3o e Remo\u00e7\u00e3o de Tronco de \u00c1rvore",
    sub_group_id: 32,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 88,
    title: "Valoriza\u00e7\u00e3o Imobili\u00e1ria",
    sub_group_id: 17,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 309,
    title: "Vidraceiro",
    sub_group_id: 54,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  },
  {
    id: 310,
    title: "Vitrais",
    sub_group_id: 54,
    created_at: null,
    updated_at: null,
    main_group_id: 2
  }
];

export const group3 = [
  {
    id: 312,
    title: "Auditoria Energ\u00e9tica",
    sub_group_id: 55,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 313,
    title: "Certifica\u00e7\u00e3o Ac\u00fastica",
    sub_group_id: 56,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 311,
    title: "Certifica\u00e7\u00e3o Energ\u00e9tica de edificios",
    sub_group_id: 55,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 314,
    title: "Certifica\u00e7\u00e3o de Instala\u00e7\u00f5es El\u00e9ctricas",
    sub_group_id: 57,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 315,
    title: "Inspe\u00e7\u00e3o da Qualidade do Ar",
    sub_group_id: 58,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 316,
    title: "Inspe\u00e7\u00e3o de Bolor",
    sub_group_id: 58,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 317,
    title: "Inspe\u00e7\u00e3o de Chamin\u00e9",
    sub_group_id: 58,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 318,
    title: "Inspe\u00e7\u00e3o de Condom\u00ednio",
    sub_group_id: 58,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 319,
    title: "Inspe\u00e7\u00e3o de Extintores",
    sub_group_id: 58,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  },
  {
    id: 320,
    title: "Inspe\u00e7\u00e3o de T\u00e9rmites e Pragas",
    sub_group_id: 58,
    created_at: null,
    updated_at: null,
    main_group_id: 3
  }
];

export const group4 = [
  {
    id: 321,
    title: "Instala\u00e7\u00e3o de Aquecimento Central",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 329,
    title: "Instala\u00e7\u00e3o de Ar Condicionado",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 330,
    title: "Instala\u00e7\u00e3o de Ar Condicionado de Parede ou Port\u00e1til",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 322,
    title: "Instala\u00e7\u00e3o de Caldeira",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 323,
    title: "Instala\u00e7\u00e3o de Lareiras e Chamin\u00e9s",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 324,
    title: "Instala\u00e7\u00e3o de Recuperador de Calor",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 325,
    title: "Instala\u00e7\u00e3o de Salamandra",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 331,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Exaustor de Cozinha",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 332,
    title:
      "Instala\u00e7\u00e3o ou Substitui\u00e7\u00e3o de Ventilador de Casa de Banho",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 333,
    title: "Limpeza de Tubagem de Ventila\u00e7\u00e3o",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 334,
    title: "Manuten\u00e7\u00e3o de Ar Condicionado",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 326,
    title: "Repara\u00e7\u00e3o de Aquecedores El\u00e9ctricos ou a G\u00e1s",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 327,
    title: "Repara\u00e7\u00e3o de Aquecimento Central",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 335,
    title: "Repara\u00e7\u00e3o de Ar Condicionado/Ventila\u00e7\u00e3o",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 336,
    title: "Repara\u00e7\u00e3o de Recuperador de Calor",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 337,
    title: "Repara\u00e7\u00e3o de Salamandra",
    sub_group_id: 60,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  },
  {
    id: 328,
    title:
      "Repara\u00e7\u00e3o ou Manuten\u00e7\u00e3o de Sistemas de Aquecimento",
    sub_group_id: 59,
    created_at: null,
    updated_at: null,
    main_group_id: 4
  }
];

export const group5 = [
  {
    id: 483,
    title: "Acolchoamento",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 338,
    title: "Advogado - Direito Civil",
    sub_group_id: 61,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 339,
    title: "Advogado - Direito Comercial",
    sub_group_id: 61,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 340,
    title: "Advogado - Direito Criminal",
    sub_group_id: 61,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 341,
    title: "Advogado - Direito Fiscal",
    sub_group_id: 61,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 342,
    title: "Advogado - Direito Imobili\u00e1rio",
    sub_group_id: 61,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 343,
    title: "Advogado - Direito Laboral",
    sub_group_id: 61,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 344,
    title: "Advogado - Direito de Fam\u00edlia e Div\u00f3rcios",
    sub_group_id: 61,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 458,
    title: "Advogado de Contratos",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 459,
    title: "Advogado de Danos Pessoais",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 461,
    title: "Advogado de Direito Internacional",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 460,
    title: "Advogado de Direito Internacional",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 462,
    title: "Advogado de Imigra\u00e7\u00e3o",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 463,
    title: "Advogado de Insolv\u00eancias",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 464,
    title: "Advogado de Marcas Registadas",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 465,
    title: "Advogado de Patentes",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 466,
    title: "Advogado de Propriedade Intelectual",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 467,
    title: "Advogado em Direito de Tr\u00e2nsito",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 468,
    title: "Advogado para Casos de Defici\u00eancia",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 469,
    title: "Advogados",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 440,
    title: "Afina\u00e7\u00e3o de Piano",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 345,
    title: "Agentes e Mediadores de Seguros",
    sub_group_id: 62,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 346,
    title: "Ag\u00eancias de Viagens",
    sub_group_id: 63,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 494,
    title: "Alojamento de Websites",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 375,
    title: "Anima\u00e7\u00e3o Gr\u00e1fica",
    sub_group_id: 72,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 347,
    title: "Autocad e Modela\u00e7\u00e3o",
    sub_group_id: 64,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 348,
    title: "Babysitting",
    sub_group_id: 65,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 484,
    title: "Bordados",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 417,
    title: "Cat Sitting",
    sub_group_id: 81,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 410,
    title: "Centro de C\u00f3pias",
    sub_group_id: 78,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 485,
    title: "Cestos Presente Personalizados",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 414,
    title: "Composi\u00e7\u00e3o de Can\u00e7\u00f5es",
    sub_group_id: 79,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 351,
    title: "Consultoria Empresarial",
    sub_group_id: 67,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 486,
    title: "Consultoria de Belas Artes",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 355,
    title: "Consultoria de E-commerce",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 356,
    title: "Consultoria de Estrat\u00e9gia de Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 352,
    title: "Consultoria de Estrat\u00e9gia e Opera\u00e7\u00f5es",
    sub_group_id: 67,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 349,
    title: "Consultoria e Aconselhamento de Seguran\u00e7a Social",
    sub_group_id: 66,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 353,
    title: "Consultoria e Desenvolvimento de Franchising",
    sub_group_id: 67,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 367,
    title: "Contabilidade",
    sub_group_id: 70,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 402,
    title: "Creche para C\u00e3es",
    sub_group_id: 75,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 487,
    title: "Croch\u00e9",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 371,
    title: "Cuidados para Animais",
    sub_group_id: 71,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 372,
    title: "Cuidados para C\u00e3es",
    sub_group_id: 71,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 373,
    title: "Cuidados para Gatos",
    sub_group_id: 71,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 495,
    title: "Desenvolvimento de Aplica\u00e7\u00f5es iOS",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 496,
    title: "Desenvolvimento de Jogos para Dispositivos M\u00f3veis",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 497,
    title: "Desenvolvimento de Software",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 498,
    title: "Desenvolvimento de Software Mobile",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 376,
    title: "Design Gr\u00e1fico",
    sub_group_id: 72,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 499,
    title: "Design de Aplica\u00e7\u00f5es M\u00f3veis",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 377,
    title: "Design de Apresenta\u00e7\u00f5es",
    sub_group_id: 72,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 500,
    title: "Design de Blogs",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 378,
    title: "Design de Impress\u00e3o",
    sub_group_id: 72,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 379,
    title: "Design de Logotipos",
    sub_group_id: 72,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 501,
    title: "Design de UI",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 357,
    title: "Direct Mail Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 418,
    title: "Dog Sitting",
    sub_group_id: 81,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 419,
    title: "Dog Walking",
    sub_group_id: 81,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 502,
    title: "E-commerce",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 382,
    title: "Edi\u00e7\u00e3o de Conte\u00fados",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 383,
    title: "Elabora\u00e7\u00e3o de Curr\u00edculos",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 358,
    title: "Email Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 380,
    title: "Entrega de Refei\u00e7\u00f5es",
    sub_group_id: 73,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 381,
    title: "Entregas e Servi\u00e7os de Estafetas",
    sub_group_id: 73,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 384,
    title: "Escrita",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 385,
    title: "Escrita de Conte\u00fados Online",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 386,
    title: "Escrita em Blog",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 470,
    title: "Especialistas em Servi\u00e7os Legais",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 471,
    title: "Especialistas em Servi\u00e7os Processuais",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 422,
    title: "Estofador de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 488,
    title: "Fabrico de Pl\u00e1stico",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 476,
    title: "Genealogia",
    sub_group_id: 91,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 354,
    title: "Gest\u00e3o de Projetos",
    sub_group_id: 67,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 415,
    title: "Grava\u00e7\u00e3o de M\u00fasica",
    sub_group_id: 79,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 489,
    title: "Grava\u00e7\u00e3o de Objetos",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 403,
    title: "Hotel de Animais de Estima\u00e7\u00e3o",
    sub_group_id: 75,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 404,
    title: "Hotel para C\u00e3es",
    sub_group_id: 75,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 405,
    title: "Hotel para Gatos",
    sub_group_id: 75,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 409,
    title: "Ilustra\u00e7\u00e3o",
    sub_group_id: 77,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 411,
    title: "Impress\u00e3o em 3D",
    sub_group_id: 78,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 429,
    title: "Instala\u00e7\u00e3o e Configura\u00e7\u00e3o de Router",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 472,
    title: "Interpreta\u00e7\u00e3o de Linguagem Jur\u00eddica",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 451,
    title: "Introdu\u00e7\u00e3o de Dados",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 477,
    title: "Investiga\u00e7\u00e3o Paranormal",
    sub_group_id: 91,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 478,
    title: "Investiga\u00e7\u00e3o Privada",
    sub_group_id: 91,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 490,
    title: "Joalharia Personalizada",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 359,
    title: "Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 360,
    title: "Marketing Digital",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 374,
    title: "Massagem para Animais de Estima\u00e7\u00e3o",
    sub_group_id: 71,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 473,
    title: "Media\u00e7\u00e3o de Conflitos",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 423,
    title: "Mudar Pneus",
    sub_group_id: 83,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 416,
    title: "Not\u00e1rio",
    sub_group_id: 80,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 424,
    title: "Oficinas de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 361,
    title: "Otimiza\u00e7\u00e3o de Motores de Busca (SEO)",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 452,
    title: "Pesquisa na Internet",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 420,
    title: "Pet Sitting",
    sub_group_id: 81,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 425,
    title: "Pintura de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 368,
    title:
      "Prepara\u00e7\u00e3o de Declara\u00e7\u00e3o de Impostos Individual",
    sub_group_id: 70,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 369,
    title: "Prepara\u00e7\u00e3o de Declara\u00e7\u00f5es de Impostos",
    sub_group_id: 70,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 370,
    title:
      "Prepara\u00e7\u00e3o de Declara\u00e7\u00f5es de Impostos de Empresas",
    sub_group_id: 70,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 474,
    title: "Prepara\u00e7\u00e3o de Documenta\u00e7\u00e3o Legal",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 479,
    title: "Preven\u00e7\u00e3o e Resolu\u00e7\u00e3o de Dist\u00farbios",
    sub_group_id: 92,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 350,
    title: "Profissionais Financeiros e de Planeamento",
    sub_group_id: 66,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 503,
    title: "Programa\u00e7\u00e3o Web",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 362,
    title: "Publicidade",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 365,
    title: "Recrutamento",
    sub_group_id: 69,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 366,
    title: "Recursos Humanos e Gest\u00e3o de Sal\u00e1rios",
    sub_group_id: 69,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 453,
    title: "Rela\u00e7\u00f5es P\u00fablicas",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 430,
    title: "Remo\u00e7\u00e3o de V\u00edrus",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 426,
    title: "Repara\u00e7\u00e3o de Autom\u00f3veis",
    sub_group_id: 83,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 441,
    title: "Repara\u00e7\u00e3o de Caixas ATM",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 431,
    title: "Repara\u00e7\u00e3o de Computador Apple",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 432,
    title: "Repara\u00e7\u00e3o de Computador Pessoal",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 433,
    title: "Repara\u00e7\u00e3o de Computadores",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 442,
    title: "Repara\u00e7\u00e3o de Equipamento Desportivo",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 443,
    title: "Repara\u00e7\u00e3o de Equipamento para Crian\u00e7as",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 437,
    title: "Repara\u00e7\u00e3o de Fotocopiadora",
    sub_group_id: 85,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 438,
    title: "Repara\u00e7\u00e3o de Impressora",
    sub_group_id: 85,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 439,
    title: "Repara\u00e7\u00e3o de Impressora e Fotocopiadora",
    sub_group_id: 85,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 444,
    title: "Repara\u00e7\u00e3o de Mesas de Bilhar",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 427,
    title: "Repara\u00e7\u00e3o de Motas",
    sub_group_id: 83,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 445,
    title: "Repara\u00e7\u00e3o de M\u00e1quinas de Constru\u00e7\u00e3o",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 446,
    title: "Repara\u00e7\u00e3o de M\u00e1quinas de Venda Autom\u00e1tica",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 406,
    title: "Repara\u00e7\u00e3o de Terminais de Pagamento",
    sub_group_id: 76,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 448,
    title: "Repara\u00e7\u00e3o e Assist. T\u00e9cnica - Smartphones e Tablets",
    sub_group_id: 87,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 449,
    title: "Repara\u00e7\u00e3o e Assist. T\u00e9cnica - TV",
    sub_group_id: 88,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 421,
    title: "Retratos Art\u00edsticos",
    sub_group_id: 82,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 491,
    title: "Revestimento com Tinta em P\u00f3",
    sub_group_id: 93,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 428,
    title: "Revis\u00e3o Autom\u00f3vel",
    sub_group_id: 83,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 363,
    title: "SMS Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 480,
    title: "Seguran\u00e7a",
    sub_group_id: 92,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 481,
    title: "Seguran\u00e7a para Eventos",
    sub_group_id: 92,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 454,
    title: "Servi\u00e7o de Apoio ao Cliente",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 482,
    title: "Servi\u00e7o de Guarda Costas",
    sub_group_id: 92,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 455,
    title:
      "Servi\u00e7o de M\u00e1quinas de Controlo Num\u00e9rico Computarizado",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 434,
    title: "Servi\u00e7o de Recupera\u00e7\u00e3o de Dados",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 435,
    title: "Servi\u00e7o de Suporte T\u00e9cnico",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 450,
    title: "Servi\u00e7os Empresariais",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 412,
    title: "Servi\u00e7os de Impress\u00e3o",
    sub_group_id: 78,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 436,
    title:
      "Servi\u00e7os de Recupera\u00e7\u00e3o e Reposi\u00e7\u00e3o de Dados",
    sub_group_id: 84,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 407,
    title: "Sistemas Telef\u00f3nicos",
    sub_group_id: 76,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 364,
    title: "Social Media Marketing",
    sub_group_id: 68,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 475,
    title: "Solicitadores",
    sub_group_id: 90,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 456,
    title: "Suporte Administrativo",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 408,
    title: "Suporte de Redes e Sistemas",
    sub_group_id: 76,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 457,
    title: "Telemarketing e Televendas",
    sub_group_id: 89,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 413,
    title: "Tipografias",
    sub_group_id: 78,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 387,
    title: "Tradu\u00e7\u00e3o",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 388,
    title: "Tradu\u00e7\u00e3o de Alem\u00e3o",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 389,
    title: "Tradu\u00e7\u00e3o de Chin\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 390,
    title: "Tradu\u00e7\u00e3o de Espanhol",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 391,
    title: "Tradu\u00e7\u00e3o de Franc\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 392,
    title: "Tradu\u00e7\u00e3o de Grego",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 393,
    title: "Tradu\u00e7\u00e3o de Holand\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 394,
    title: "Tradu\u00e7\u00e3o de Ingl\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 395,
    title: "Tradu\u00e7\u00e3o de Italiano",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 396,
    title: "Tradu\u00e7\u00e3o de Japon\u00eas",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 397,
    title: "Tradu\u00e7\u00e3o de Mandarim",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 398,
    title: "Tradu\u00e7\u00e3o de Russo",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 399,
    title: "Tradu\u00e7\u00e3o de \u00c1rabe",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 400,
    title: "Transcri\u00e7\u00e3o",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 401,
    title: "Transcri\u00e7\u00e3o M\u00e9dica",
    sub_group_id: 74,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 492,
    title: "Treino de C\u00e3es",
    sub_group_id: 94,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 447,
    title: "T\u00e9cnico de Aqu\u00e1rios",
    sub_group_id: 86,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 493,
    title: "Veterin\u00e1rios",
    sub_group_id: 95,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 504,
    title: "Web Design",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  },
  {
    id: 505,
    title: "Web Development",
    sub_group_id: 96,
    created_at: null,
    updated_at: null,
    main_group_id: 5
  }
];

export const group6 = [
  {
    id: 607,
    title: "Aulas de Alem\u00e3o",
    sub_group_id: 136,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 508,
    title: "Aulas de Artes e Trabalhos Manuais",
    sub_group_id: 98,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 524,
    title: "Aulas de Basquetebol",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 542,
    title: "Aulas de Canto",
    sub_group_id: 109,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 543,
    title: "Aulas de Canto (para Adultos)",
    sub_group_id: 109,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 544,
    title: "Aulas de Canto (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 109,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 560,
    title: "Aulas de Composi\u00e7\u00e3o Musical",
    sub_group_id: 116,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 574,
    title: "Aulas de Condu\u00e7\u00e3o",
    sub_group_id: 123,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 551,
    title: "Aulas de Contrabaixo (para Adultos)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 552,
    title: "Aulas de Contrabaixo (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 512,
    title: "Aulas de Coreografia",
    sub_group_id: 100,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 537,
    title: "Aulas de Corrida e Jogging",
    sub_group_id: 105,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 509,
    title: "Aulas de Costura",
    sub_group_id: 99,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 510,
    title: "Aulas de Croch\u00e9",
    sub_group_id: 99,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 513,
    title: "Aulas de Dan\u00e7a Privadas",
    sub_group_id: 100,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 514,
    title: "Aulas de Dan\u00e7a de Sal\u00e3o",
    sub_group_id: 100,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 519,
    title: "Aulas de Defesa Pessoal",
    sub_group_id: 101,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 521,
    title: "Aulas de Desenho",
    sub_group_id: 102,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 535,
    title: "Aulas de Equita\u00e7\u00e3o (para Adultos)",
    sub_group_id: 104,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 536,
    title: "Aulas de Equita\u00e7\u00e3o (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 104,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 522,
    title: "Aulas de Escultura",
    sub_group_id: 102,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 608,
    title: "Aulas de Espanhol",
    sub_group_id: 137,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 539,
    title: "Aulas de Fotografia",
    sub_group_id: 106,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 609,
    title: "Aulas de Franc\u00eas",
    sub_group_id: 138,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 525,
    title: "Aulas de Futebol",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 526,
    title: "Aulas de Golfe",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 546,
    title: "Aulas de Guitarra",
    sub_group_id: 111,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 547,
    title: "Aulas de Guitarra (para Adultos)",
    sub_group_id: 111,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 548,
    title: "Aulas de Guitarra (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 111,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 549,
    title: "Aulas de Guitarra Baixo",
    sub_group_id: 111,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 553,
    title: "Aulas de Harm\u00f3nica",
    sub_group_id: 113,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 554,
    title: "Aulas de Harpa (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 540,
    title: "Aulas de Inform\u00e1tica",
    sub_group_id: 107,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 610,
    title: "Aulas de Ingl\u00eas",
    sub_group_id: 139,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 611,
    title: "Aulas de Italiano",
    sub_group_id: 140,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 612,
    title: "Aulas de Japon\u00eas",
    sub_group_id: 141,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 506,
    title: "Aulas de Judo",
    sub_group_id: 97,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 507,
    title: "Aulas de Karat\u00e9",
    sub_group_id: 97,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 527,
    title: "Aulas de Kitesurf",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 515,
    title: "Aulas de Kizomba",
    sub_group_id: 100,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 520,
    title: "Aulas de Krav Maga",
    sub_group_id: 101,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 613,
    title: "Aulas de Linguagem Gestual",
    sub_group_id: 141,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 614,
    title: "Aulas de Mandarim",
    sub_group_id: 141,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 597,
    title: "Aulas de Maquilhagem",
    sub_group_id: 134,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 528,
    title: "Aulas de Mergulho",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 541,
    title: "Aulas de M\u00fasica - Bateria",
    sub_group_id: 108,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 545,
    title: "Aulas de M\u00fasica - Clarinete",
    sub_group_id: 110,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 529,
    title: "Aulas de Nata\u00e7\u00e3o Privadas (individuais ou em grupo)",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 555,
    title: "Aulas de Obo\u00e9 (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 113,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 550,
    title: "Aulas de Org\u00e3o",
    sub_group_id: 112,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 556,
    title: "Aulas de Piano",
    sub_group_id: 114,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 557,
    title: "Aulas de Piano (para Adultos)",
    sub_group_id: 114,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 558,
    title: "Aulas de Piano (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 114,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 523,
    title: "Aulas de Pintura",
    sub_group_id: 102,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 615,
    title: "Aulas de Portugu\u00eas (como Segunda L\u00edngua)",
    sub_group_id: 142,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 571,
    title: "Aulas de Reanima\u00e7\u00e3o Neonatal",
    sub_group_id: 122,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 516,
    title: "Aulas de Salsa Privadas",
    sub_group_id: 100,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 517,
    title: "Aulas de Sapateado",
    sub_group_id: 100,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 559,
    title: "Aulas de Saxofone",
    sub_group_id: 115,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 598,
    title: "Aulas de Soldagem",
    sub_group_id: 134,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 530,
    title: "Aulas de Stand-Up Paddle",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 531,
    title: "Aulas de Surf",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 518,
    title: "Aulas de Tango",
    sub_group_id: 100,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 561,
    title: "Aulas de Teoria Musical",
    sub_group_id: 116,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 511,
    title: "Aulas de Tric\u00f4",
    sub_group_id: 99,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 562,
    title: "Aulas de Trompete",
    sub_group_id: 117,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 532,
    title: "Aulas de T\u00e9nis Privadas (individuais ou em grupo)",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 563,
    title: "Aulas de Ukelele",
    sub_group_id: 118,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 564,
    title: "Aulas de Viola",
    sub_group_id: 119,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 565,
    title: "Aulas de Viola (para Adultos)",
    sub_group_id: 119,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 566,
    title: "Aulas de Viola (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 119,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 567,
    title: "Aulas de Violino",
    sub_group_id: 120,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 568,
    title: "Aulas de Violino (para Adultos)",
    sub_group_id: 120,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 569,
    title: "Aulas de Violino (para Crian\u00e7as ou Adolescentes)",
    sub_group_id: 120,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 570,
    title: "Aulas de Violoncelo",
    sub_group_id: 121,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 533,
    title: "Aulas de Voleibol",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 534,
    title: "Aulas de Xadrez",
    sub_group_id: 103,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 538,
    title: "Aulas de Zumba",
    sub_group_id: 105,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 580,
    title: "Explica\u00e7\u00f5es de Biologia",
    sub_group_id: 125,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 581,
    title: "Explica\u00e7\u00f5es de Ci\u00eancias",
    sub_group_id: 126,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 587,
    title: "Explica\u00e7\u00f5es de C\u00e1lculo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 582,
    title: "Explica\u00e7\u00f5es de Economia",
    sub_group_id: 127,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 583,
    title: "Explica\u00e7\u00f5es de Estat\u00edstica",
    sub_group_id: 128,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 584,
    title: "Explica\u00e7\u00f5es de F\u00edsica",
    sub_group_id: 129,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 585,
    title: "Explica\u00e7\u00f5es de Geometria",
    sub_group_id: 130,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 586,
    title: "Explica\u00e7\u00f5es de Hist\u00f3ria",
    sub_group_id: 131,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 588,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica de Ensino Secund\u00e1rio",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 589,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica de Mestrado",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 590,
    title:
      "Explica\u00e7\u00f5es de Matem\u00e1tica de N\u00edvel Universit\u00e1rio",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 591,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica do 1\u00ba Ciclo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 592,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica do 2\u00ba Ciclo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 593,
    title: "Explica\u00e7\u00f5es de Matem\u00e1tica do 3\u00ba Ciclo",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 575,
    title: "Explica\u00e7\u00f5es de Prepara\u00e7\u00e3o para o GMAT",
    sub_group_id: 124,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 576,
    title:
      "Explica\u00e7\u00f5es de Prepara\u00e7\u00e3o para os Exames Nacionais",
    sub_group_id: 124,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 596,
    title: "Explica\u00e7\u00f5es de Qu\u00edmica",
    sub_group_id: 133,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 594,
    title: "Explica\u00e7\u00f5es de Trigonometria",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 577,
    title: "Explica\u00e7\u00f5es de V\u00e1rias Disciplinas",
    sub_group_id: 124,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 595,
    title: "Explica\u00e7\u00f5es de \u00c1lgebra",
    sub_group_id: 132,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 578,
    title: "Explica\u00e7\u00f5es para o Exame LSAT",
    sub_group_id: 124,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 579,
    title: "Forma\u00e7\u00e3o de Professores",
    sub_group_id: 124,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 600,
    title: "Forma\u00e7\u00e3o em Contabilidade",
    sub_group_id: 135,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 601,
    title: "Forma\u00e7\u00e3o em Desenvolvimento de Lideran\u00e7a",
    sub_group_id: 135,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 602,
    title: "Forma\u00e7\u00e3o em Finan\u00e7as Empresariais",
    sub_group_id: 135,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 603,
    title: "Forma\u00e7\u00e3o em Finan\u00e7as Pessoais",
    sub_group_id: 135,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 599,
    title: "Forma\u00e7\u00e3o em Imobili\u00e1ria",
    sub_group_id: 134,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 604,
    title: "Forma\u00e7\u00e3o em Marketing",
    sub_group_id: 135,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 605,
    title: "Forma\u00e7\u00e3o em Otimiza\u00e7\u00e3o de Motores de Busca",
    sub_group_id: 135,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 572,
    title: "Forma\u00e7\u00e3o em Primeiros Socorros",
    sub_group_id: 122,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 573,
    title: "Forma\u00e7\u00e3o em Seguran\u00e7a e Primeiros Socorros",
    sub_group_id: 122,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  },
  {
    id: 606,
    title: "Forma\u00e7\u00e3o em Vendas",
    sub_group_id: 135,
    created_at: null,
    updated_at: null,
    main_group_id: 6
  }
];



// WEBPACK FOOTER //
// ./src/plugins/serviceList.js